(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWostrich_atlas_", frames: [[349,448,110,226],[112,511,110,226],[461,506,110,226],[0,511,110,226],[0,382,229,127],[674,260,208,208],[342,270,176,176],[765,802,116,142],[0,739,116,142],[445,886,110,112],[102,891,110,112],[655,1008,90,72],[0,1019,78,66],[231,382,70,64],[747,1034,70,68],[0,883,100,134],[883,802,112,144],[669,606,94,228],[838,572,94,228],[573,606,94,228],[349,676,94,228],[964,0,60,172],[765,606,60,172],[408,1000,91,89],[102,1005,91,89],[855,948,96,86],[330,906,96,86],[214,984,95,86],[311,994,95,86],[757,946,96,86],[557,956,96,86],[224,680,114,150],[445,734,114,150],[224,832,104,150],[118,739,104,150],[520,270,116,234],[231,448,116,230],[561,836,116,118],[884,260,102,310],[674,0,288,258],[342,0,330,268],[679,836,76,170],[934,572,78,170],[0,0,340,380],[638,470,198,134]]}
];


// symbols:



(lib.BackLeg0001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.BackLeg0002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.BackLeg0003 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.BackLeg0004 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.Body = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.OstrichBodyFeathers0001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.OstrichBodyFeathers0002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.OstrichFootB_0010001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.OstrichFootB_0010002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.OstrichHead_001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.OstrichHead_003 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.OstrichHead_005 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.OstrichHead_007 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.OstrichLegBLower_001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.OstrichLegBUpper_001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.OstrichLeg0001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.OstrichLeg0002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.OstrichLeg0003 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.OstrichLeg0004 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.OstrichNeck0001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.OstrichNeck0002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTail0001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTail0002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTail_0020001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTail_0020002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTail_0030001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTail_0030002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTail_0040001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTail_0040002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTorsoFeathers20001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTorsoFeathers20002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTorsoFeathers30001 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.OstrichTorsoFeathers30002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.OstrichWingspanLeftLowerLeg0002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.OstrichWingspanLowerRightLeg0002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.OstrichWingspanNeckFeathers = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.OstrichWingspanNeck = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.OstrichWingspanTorsoFeathers = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.OstrichWingspanTorso = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.OstrichWingspanUpperLeftLeg0002 = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.OstrichWingspanUpperRightLeg = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib.OstrichWingspanWing = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib.Wing = function() {
	this.spriteSheet = ss["MWostrich_atlas_"];
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.ToucanTween8s1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F2F2F2").s().p("AALAWQAAAAgBAAQAAAAAAgBQAAAAAAAAQgBgBAAAAIAAgCIAAAAQgBgEABgCIABgCQAAgBABAAQAAgBAAAAQABAAAAgBQABAAAAAAQACgBADABIACABIADADIAAAFQgBAEgCABIgGABQAEAEAEgCQADgEAAgJQAAgKgJgLQgJgLgKgCQgJgBgJACIgFABIgCAAIAAgBQgBAAAAAAIABgBIAHgCQAKgDALACQALABAKAPQALAOgDALQgDALgDAAIAAAAIgFACQgEAAgDgGgAAOAKIgCACQgCADABADIABABQAIACAAgEQABgFgCgBIgDgBIgCAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.9,-2.7,6,5.6);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.OstrichWingspanWing_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.OstrichWingspanWing();
	this.instance.parent = this;
	this.instance.setTransform(-2.4,-8.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichWingspanWing_1, new cjs.Rectangle(-2.4,-8.1,170,190), null);


(lib.OstrichWingspanUpperRightLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.OstrichWingspanUpperRightLeg();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichWingspanUpperRightLeg_1, new cjs.Rectangle(-2,-2,39,85), null);


(lib.OstrichWingspanUpperLeftLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.OstrichWingspanUpperLeftLeg0002();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-18.1,-2,58.9,85);


(lib.OstrichWingspanTorsoFeathers_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.OstrichWingspanTorsoFeathers();
	this.instance.parent = this;
	this.instance.setTransform(-10,-9.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichWingspanTorsoFeathers_1, new cjs.Rectangle(-10,-9.9,144,129), null);


(lib.OstrichWingspanTorso_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.OstrichWingspanTorso();
	this.instance.parent = this;
	this.instance.setTransform(-2,-1.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichWingspanTorso_1, new cjs.Rectangle(-2,-1.9,165,134), null);


(lib.OstrichWingspanNeckFeathers_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.OstrichWingspanNeckFeathers();
	this.instance.parent = this;
	this.instance.setTransform(-3.9,-3.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichWingspanNeckFeathers_1, new cjs.Rectangle(-3.9,-3.9,58,59), null);


(lib.OstrichWingspanNeck_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.OstrichWingspanNeck();
	this.instance.parent = this;
	this.instance.setTransform(-2.9,-2.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichWingspanNeck_1, new cjs.Rectangle(-2.9,-2.9,51,155), null);


(lib.OstrichWingspanLowerRightLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.OstrichWingspanLowerRightLeg0002();
	this.instance.parent = this;
	this.instance.setTransform(-4,-6.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4,-6.9,68.3,115);


(lib.OstrichWingspanLegFeathers = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#BB553C").s().p("Ag1B2QgJgOAAgNQgEAKgKAGQgIAGgJABQgMABgIgLQgJgNADgQQgSAMgRgDIgNgFQgEgGgBgHQgDgLAKgOQgTAFgIgOQgEgHAAgKQAAgNAIgIIgHgRQAAgUAQgFQAhhJBagIQCHgEBCBCQAtAtAAA2QAAAMADADQADADABALQABAJgFANQgHATgRACQgLACgHgEQgHARgIABQgTACgPgLQgHAOgPACQgTACgUgVIgCgCQAAAWgWACQgRACgMgkQABAMgIAMQgIAKgIABIgBAAQgJAAgIgNg");
	this.shape.setTransform(19.7,1.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichWingspanLegFeathers, new cjs.Rectangle(0,-11.2,39.5,26.1), null);


(lib.OstrichWingspanLeftLowerLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.OstrichWingspanLeftLowerLeg0002();
	this.instance.parent = this;
	this.instance.setTransform(-1,-7.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-19.1,-7.7,76.1,117);


(lib.OstrichLegBUpper_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.OstrichLegBUpper_001();
	this.instance.parent = this;
	this.instance.setTransform(-9.9,-11,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichLegBUpper_001_1, new cjs.Rectangle(-9.9,-11,56,72), null);


(lib.OstrichLegBLower_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.OstrichLegBLower_001();
	this.instance.parent = this;
	this.instance.setTransform(6.1,-14.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichLegBLower_001_1, new cjs.Rectangle(6.1,-14.7,50,67), null);


(lib.OstrichHead_007_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.OstrichHead_007();
	this.instance.parent = this;
	this.instance.setTransform(-11.7,-11.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichHead_007_1, new cjs.Rectangle(-11.7,-11.7,35,34), null);


(lib.OstrichHead_005_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.OstrichHead_005();
	this.instance.parent = this;
	this.instance.setTransform(-12.4,-11.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichHead_005_1, new cjs.Rectangle(-12.4,-11.7,35,32), null);


(lib.OstrichHead_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.OstrichHead_003();
	this.instance.parent = this;
	this.instance.setTransform(-15,-11.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichHead_003_1, new cjs.Rectangle(-15.1,-11.7,39.1,33), null);


(lib.OstrichHead_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.OstrichHead_001();
	this.instance.parent = this;
	this.instance.setTransform(-21.5,-11.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.OstrichHead_001_1, new cjs.Rectangle(-23.5,-11.7,47.1,36), null);


(lib.OstrichFootB_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.OstrichFootB_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-11,-11.4,0.5,0.5);

	this.instance_1 = new lib.OstrichFootB_0010002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-11,-11.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11,-11.4,55,56);


(lib.ostrich_tailGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("ACjhXQALAYAOAoQAQArAAAeQAAAUgJAVQgPAkgiAAQgNAAgLgEQgSAtgcAAQgRAAgLghQAAABAAABQgSA8gsAAQgeAAgOgXQgJADgKAAQgaAAgGgPQAAgCAAgCQgIAEgJAAQgKAAgFgEQgBAAgEgEQgjACgNgNQgJgHAAgLQAAgZArgcQAogZgIgoQgGghALADQgJgPAAgBQAAgqAVgGQADgBADABQgBgDAAgCQAAgQAJgFQgJgLAAgUQAAgXAUgBQALgBAMABQgBgEAAgEQAAgcA6AMQAlAHAnARQAWAHAeAZQAeAZALAYg");
	this.shape.setTransform(20.4,19.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.ostrich_tailGlow, new cjs.Rectangle(-2,-2,44.8,43.4), null);


(lib.ostrich_neckGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AhJkwQACgTAEg0QAlAOA4gOQgGAfgJA0QgXCQAABFQAACPBRBSQAMALAJAKQg0BlAPBsQhEgYgqiJQgQg0gIg2QgJg2ABgSQAAgSAFh1QAFh3ABgTQABgUAEgwg");
	this.shape.setTransform(9,46.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.ostrich_neckGlow, new cjs.Rectangle(-2,7.1,22.1,79.3), null);


(lib.ostrich_legMud_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_loop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:220,"final":301,final_loop:302});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AglAyQgTgGgBgUIgCgbIgSgUIAEgCIAIABIAsgMIAVgHIAMgGQATgHARgCIADgDQACgEAEgBQACADAFgEIACgBQADAHAAAJIgOAYQAXACAAAXQAAAFgDAFIgCABIgEgBIgHAGQgBgBAAAAQAAAAgBAAQAAAAgBAAQAAAAgBAAIgCACIgEAFIgCAAIgCABIgDADQgHAEgDAAIgDAEQgXAQgSAWIgcgTgAgIBEIABAAIAAABIgBgBg");
	this.shape.setTransform(13.7,19.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},2).wait(2).to({_off:false},0).to({_off:true},2).wait(297));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(6,12.9,15.6,13.8);


(lib.ostrich_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("ACdhYQAOAhAAAUQAABagIAPQgHAQAUDKQgvAcgmgcQgcjTgPgfQgNgngRgfIiEEXQgyAIgLgcQBMjOARgyQgUhPAFgqIAAgBQgJgHgFgGQgcgfgUg6QgOgoA1gQQAGA8BSgjQAJBAA0AqQA0AqA8gIQACASAOAeg");
	this.shape.setTransform(16.3,32);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.ostrich_legGlow, new cjs.Rectangle(-3.3,-0.2,39.2,64.4), null);


(lib.ostrich_footMud_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"final":301,"final_loop":302});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AhcB1QgIgDAAgJQAAgIAPgVIATgBIAEgEIAFgCQAWgJAFgYIABAAQARgSAAgaIABgCIAAgBIABAAIgBAAIAAgCQAAgUALgCQAGgBADAGIABAAQAEAAADACIgDgIQAAgPARgCIACAAIgCgGQAAgGADgEIADgDIAAgDQAAgKAKgBQAKAAAAAKQAGAAADAFIADgEIACgCQgGgCgDgGIgDgLQAAgQATAAIADAAQABgJAJABQAKACAAAIQAAAIgFACIABAHIAAACIAAAAIAAAAIgJAOIABACIAIALIABAEQgDAYgJAWIACABQADACADABIABABQAEAIgBAIIgHAGIgWAQQgBAAAAAAQAAgBAAAAQgBAAAAAAQAAgBAAAAIAAgCQgCgGgHgDQgKACgGAHQgIALgEARQgGAXgJAVIgBABQgMAMgNAHIABABQgSADgZAAQgdAAgKgEg");
	this.shape.setTransform(9.9,12);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},2).wait(2).to({_off:false},0).to({_off:true},2).wait(297));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.2,0,20.3,24.2);


(lib.ostrich_footGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF00").s().p("AAgC2QgxgBgJgcQgCgEAAgEIAAgQQAAgnAqgRIAAAAQARgHAygGQAggEAIgEIgBAAIAYgfQAGgJAAgFQgBgFAAgDIAHg/QAAgFACgDQAJgOAKgLIAAAAIABgBIAFgFQACgDAEgBQAegLAmACIACAAQAGABAEACQAEABAEAEQAKALAJAJQAHAFAAAIIAKBSIAAACQAAA8gkA1IABAAQgpA+gygDQgcgBgRgSIgBgBIglAJQg0AMgSAAIgCAAgAAgBwIAAAAQgOAGgBAMIAAAIIAPACQAOgBAvgKIAxgMIAHgBQAKgFARAYQAEAEAHAAQAcgCAYgmIAAAAQAcgpABgvIgJhLIgKgKQgUAAgRAFQgGAHgFAHIgGA3QAHAUgVAbIAAAAIgYAeIAAABQgKARg7AHIAAAAQgpAFgPAFgADWhIIAAAAIAAAAIAAAAgAjwCkIgCAAIgSgCQgqgDgHgaQgCgDAAgDIgBgOQABgdAdgNIAAAAQAKgFAIAAQAhgPAVgyIABgKQgBgjBeh5IgBABQADgFAEgEQAGgFAJgBQAZgDAYABIAeACQAJABAHAGIAKALQAFAFABAGQABAHgDAFQgpA/gBAIQANAPAAARIgBAFQgfBjgngJIgIgBQgFAGgJAbQgVBAg4AEQgmAEgNAAIgEAAgAjwB6IABAAIAsgDQAbgGAMgjIAAgBQAZhFAmAJQAEAAADABQAEgIAQgzIgCgEIAAgBQgWgSAwhMIgBAAIgfABQhTBrgCAcIAAADIgBADQABAFgCAFQgfBPg2APQgFACgFgBQgHAEABAGIAAAEIACgBIAUACg");
	this.shape.setTransform(24.7,18.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.ostrich_footGlow, new cjs.Rectangle(-7,-2,64.1,39.7), null);


(lib.ostrich_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AF+hAQg7g6hvgRQhvgShogEQhtgGg4AVQg5AWhBAdQhBAegVAqQhPAmhGAzIAAABIAAAAQANAOAbAIQAfAJBKgBIAAAAQApAABggCQBUABA7AKQFrA/CEgHQBKgDAMgaQARgVgZgeQAhgPAKgPQAbgggsgWg");
	this.shape.setTransform(51.3,20.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.ostrich_backGlow, new cjs.Rectangle(-3.3,2,109.3,36.6), null);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.eeeeeeeeee = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F2F2F2").s().p("AALAWQAAAAgBAAQAAAAAAgBQAAAAAAAAQgBgBAAAAIAAgCIAAAAQgBgEABgCIABgCQAAgBABAAQAAgBAAAAQABAAAAgBQABAAAAAAQACgBADABIACABIADADIAAAFQgBAEgCABIgGABQAEAEAEgCQADgEAAgJQAAgKgJgLQgJgLgKgCQgJgBgJACIgFABIgCAAIAAgBQgBAAAAAAIABgBIAHgCQAKgDALACQALABAKAPQALAOgDALQgDALgDAAIAAAAIgFACQgEAAgDgGgAAOAKIgCACQgCADABADIABABQAIACAAgEQABgFgCgBIgDgBIgCAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.9,-2.7,6,5.6);


(lib.blueglowtail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ACjhXQALAYAOAoQAQArAAAeQAAAUgJAVQgPAkgiAAQgNAAgLgEQgSAtgcAAQgRAAgLghQAAABAAABQgSA8gsAAQgeAAgOgXQgJADgKAAQgaAAgGgPQAAgCAAgCQgIAEgJAAQgKAAgFgEQgBAAgEgEQgjACgNgNQgJgHAAgLQAAgZArgcQAogZgIgoQgGghALADQgJgPAAgBQAAgqAVgGQADgBADABQgBgDAAgCQAAgQAJgFQgJgLAAgUQAAgXAUgBQALgBAMABQgBgEAAgEQAAgcA6AMQAlAHAnARQAWAHAeAZQAeAZALAYg");
	this.shape.setTransform(20.4,19.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtail, new cjs.Rectangle(-2,-2,44.8,43.4), null);


(lib.blueglowneck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AhJkwQACgTAEg0QAlAOA4gOQgGAfgJA0QgXCQAABFQAACPBRBSQAMALAJAKQg0BlAPBsQhEgYgqiJQgQg0gIg2QgJg2ABgSQAAgSAFh1QAFh3ABgTQABgUAEgwg");
	this.shape.setTransform(9,46.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowneck, new cjs.Rectangle(-2,7.1,22.1,79.3), null);


(lib.blueglowlegs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ACdhYQAOAhAAAUQAABagIAPQgHAQAUDKQgvAcgmgcQgcjTgPgfQgNgngRgfIiEEXQgyAIgLgcQBMjOARgyQgUhPAFgqIAAgBQgJgHgFgGQgcgfgUg6QgOgoA1gQQAGA8BSgjQAJBAA0AqQA0AqA8gIQACASAOAeg");
	this.shape.setTransform(16.3,32);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowlegs, new cjs.Rectangle(-3.3,-0.2,39.2,64.4), null);


(lib.blueglowfeet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AERhiQAJALAKAJQAEAlAEAoQAAAzgcAuQgdAwgiAAQgQAAgpAiQAZg3gCAAQgWAHgWAGQgtAMgggIIg7ANQAsgyAJgIQAJgIARgHQASgHAhgEQAigEAHgKQAIgMANgSQANgSgEgMQADggACgdQAHgLAIgKQABgCACgBQAWgJAdABQABAAACAAgAgZioQgqBQAJAMQAHAJAAAKQAJBlgVgBQgdgXgCgCQgRAAgOAxQgNAygiAHQghAHgHAAQgHAAgIAAQgSAAABACQgzAHgEgOQgEgOAdgPQAdgPAUgEQAlgRAVhDQgBgFABgGQAAgeBIh3QACgDACgDQATgEASgBQAKAAALAAQAEAEAEAFg");
	this.shape.setTransform(25,17.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowfeet, new cjs.Rectangle(-7,-2,64.1,39.7), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AF+hAQg7g6hvgRQhvgShogEQhtgGg4AVQg5AWhBAdQhBAegVAqQhPAmhGAzIAAABIAAAAQANAOAbAIQAfAJBKgBIAAAAQApAABggCQBUABA7AKQFrA/CEgHQBKgDAMgaQARgVgZgeQAhgPAKgPQAbgggsgWg");
	this.shape.setTransform(51.3,20.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(-3.3,2,109.3,36.6), null);


(lib.Wing_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 7
	this.instance = new lib.Wing();
	this.instance.parent = this;
	this.instance.setTransform(-40.2,-23.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Wing_1, new cjs.Rectangle(-40.2,-23.2,99,67), null);


(lib.OstrichTorsoFeathers3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_stop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"final":210,"final_loop":211});

	// Layer 3
	this.instance = new lib.OstrichTorsoFeathers30001();
	this.instance.parent = this;
	this.instance.setTransform(-3.5,-3.9,0.5,0.5);

	this.instance_1 = new lib.OstrichTorsoFeathers30002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-3.5,-3.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},206).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.5,-5.4,52,76.5);


(lib.OstrichTorsoFeathers2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"final":210,"final_loop":211});

	// Layer 3
	this.instance = new lib.OstrichTorsoFeathers20001();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2.9,0.5,0.5);

	this.instance_1 = new lib.OstrichTorsoFeathers20002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-2,-2.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},206).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2,-2.9,57,75);


(lib.NeckFeathers = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = getMCSymbolPrototype(lib.NeckFeathers, null, null);


(lib.Body_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Body();
	this.instance.parent = this;
	this.instance.setTransform(-55.7,-29.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.Body_1, new cjs.Rectangle(-55.8,-29.4,114.7,63.7), null);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.OstrichTail_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":69});

	// Layer 6
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(7.4,-10.6,0.334,0.334,110.1,0,0,36,10.8);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(9.9,-15.5,0.412,0.412,70.7,0,0,36,11);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(7.6,-13.2,0.562,0.562,110.1,0,0,35.9,11.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},68).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.OstrichTail_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,glowclean:6,glowclean_loop:7,"final":8,"final_loop":9});

	// Layer 7
	this.instance = new lib.OstrichTail_0040001();
	this.instance.parent = this;
	this.instance.setTransform(-6.2,-26.4,0.5,0.5);

	this.instance_1 = new lib.OstrichTail_0040002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-6.2,-26.4,0.5,0.5);

	this.instance_2 = new lib.ostrich_tailGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(16,-8.3,1,0.86,0,0,0,20.4,19.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},4).to({state:[]},1).wait(147));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10.5,-33.2,55.8,52);


(lib.OstrichTail_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"glowclean":6,"glowclean_loop":7,"final":8,"final_loop":9});

	// Layer 7
	this.instance = new lib.OstrichTail_0030001();
	this.instance.parent = this;
	this.instance.setTransform(-7,-26.2,0.5,0.5);

	this.instance_1 = new lib.OstrichTail_0030002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-7,-26.2,0.5,0.5);

	this.instance_2 = new lib.ostrich_tailGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(13.4,-8.2,1,1,0,0,0,20.4,19.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},4).to({state:[]},1).wait(147));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10.4,-31.7,53.7,50.2);


(lib.OstrichTail_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"glowclean":6,"glowclean_loop":7,"final":8,"final_loop":9});

	// Layer 7
	this.instance = new lib.OstrichTail_0020001();
	this.instance.parent = this;
	this.instance.setTransform(-5.5,-27,0.5,0.5);

	this.instance_1 = new lib.OstrichTail_0020002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-5.5,-27,0.5,0.5);

	this.instance_2 = new lib.ostrich_tailGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(14,-7.7,1,1,-9.2,0,0,20.3,19.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},4).to({state:[]},1).wait(147));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10.3,-34.9,57.5,53.5);


(lib.OstrichTail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":61,"glowclean":62,"glowclean_loop":63,"final":64,"final_loop":65});

	// Layer 7
	this.instance = new lib.OstrichTail0001();
	this.instance.parent = this;
	this.instance.setTransform(-7.9,-26.5,0.5,0.5);

	this.instance_1 = new lib.OstrichTail0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-7.9,-26.5,0.5,0.5);

	this.instance_2 = new lib.ostrich_tailGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(13.8,-6,1,1,0,0,0,20.4,19.7);

	this.glow = new lib.blueglowtail();
	this.glow.parent = this;
	this.glow.setTransform(13.8,-6,1,1,0,0,0,20.4,19.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},55).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(149));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10.1,-28.4,49.7,47.4);


(lib.OstrichNeck_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":45});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-6,-15,0.334,0.334,110.1,0,0,36,10.8);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-0.2,15.1,0.412,0.412,70.7,0,0,36,11);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-5.4,-2.3,0.441,0.441,110.1,0,0,36,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.OstrichNeck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":70,"glowclean":71,"glowclean_loop":72,"final":73,"final_loop":74});

	// Layer 3
	this.instance = new lib.OstrichNeck0001();
	this.instance.parent = this;
	this.instance.setTransform(-13,-40.9,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-6.1,-5,0.5,0.5,90,0,0,47.6,10.1);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-3.4,19.5,0.5,0.5,90,0,0,50.6,5.1);

	this.instance_3 = new lib.OstrichNeck0002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-13,-40.9,0.5,0.5);

	this.instance_4 = new lib.ostrich_neckGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-1.1,6.2,1,1,0,0,0,9,46.7);

	this.glow = new lib.blueglowneck();
	this.glow.parent = this;
	this.glow.setTransform(-1.1,6.2,1,1,0,0,0,9,46.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_4}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},9).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},55).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(140));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-13,-40.9,30,86);


(lib.OstrichLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":68});

	// Layer 4
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-18.8,29.3,0.412,0.412,-79.3,0,0,36,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-28.7,36.6,0.441,0.441,21.5,0,0,35.9,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},67).wait(1));

	// Layer 1
	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(17.9,35.1,0.412,0.412,-79.3,0,0,36,11.1);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(8,42.4,0.441,0.441,21.5,0,0,35.9,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2}]},1).to({state:[]},67).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.OstrichBodyFeathers1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":80,"glowclean":81,"glowclean_loop":82,"final":83,"final_loop":84});

	// Layer 2
	this.instance = new lib.OstrichBodyFeathers0001();
	this.instance.parent = this;
	this.instance.setTransform(-11,1.1,0.5,0.5);

	this.instance_1 = new lib.OstrichBodyFeathers0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-11,1.1,0.5,0.5);

	this.instance_2 = new lib.ostrich_backGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(57.5,3.8,1,0.999,0,-9.5,1,51.3,20.1);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(57.5,3.8,1,0.999,0,-9.5,1,51.3,20.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},74).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(130));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11,0.2,58,71.9);


(lib.OstrichBodyFeathers = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"final":210,"final_loop":211});

	// Layer 2
	this.instance = new lib.OstrichBodyFeathers0001();
	this.instance.parent = this;
	this.instance.setTransform(-11,1.1,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(34.9,24.8,1,1,20,0,0,50.6,5.2);

	this.instance_2 = new lib.OstrichBodyFeathers0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-11,1.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},44).to({state:[{t:this.instance_2}]},160).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11,0.2,58,71.9);


(lib.BackLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":68});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(28.5,-1.6,0.412,0.412,-79.3,0,0,36,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(18.6,5.7,0.441,0.441,21.5,0,0,35.9,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},67).wait(1));

	// Layer 2
	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(2.5,-10.2,0.412,0.412,-79.3,0,0,36,11.1);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-7.4,-2.9,0.441,0.441,21.5,0,0,35.9,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2}]},1).to({state:[]},67).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.BackLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 3
	this.backfootmud = new lib.ostrich_footMud_002();
	this.backfootmud.parent = this;
	this.backfootmud.setTransform(-10.1,37.6,1,1,0,0,0,11.7,12.1);

	this.backlegmud = new lib.ostrich_legMud_002();
	this.backlegmud.parent = this;
	this.backlegmud.setTransform(13.8,0.6,1,1,137.1,0,0,11.8,14.2);

	this.instance = new lib.BackLeg0004();
	this.instance.parent = this;
	this.instance.setTransform(-29,-51.2,0.5,0.5);

	this.instance_1 = new lib.BackLeg0001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-29,-51.2,0.5,0.5);

	this.instance_2 = new lib.BackLeg0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-29,-51.2,0.5,0.5);

	this.instance_3 = new lib.BackLeg0003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-29,-51.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.backlegmud},{t:this.backfootmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).wait(200));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-29,-51.2,55,113);


(lib.water_drops_011 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(182.5,4.9,0.486,0.486,0,0,180,4.7,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(70,37,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(28.6,93.4,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(2.4,41.5,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(91.1,10.7,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(132.4,67.1,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,57.2,18,23);


(lib.ostrichbackbubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":79});

	// Layer 1
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(83,14.1,0.414,0.414,-69.2,0,0,35.9,11.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.2,17.7,0.383,0.383,-72.3,0,0,35.6,11.6);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(56.5,19.2,0.383,0.383,-72.3,0,0,35.5,11.5);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54.5,5.4,0.414,0.414,-128.3,0,0,35.4,11.9);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(68.1,16.8,0.414,0.414,-12.3,0,0,35.8,11.6);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(76.5,26.5,0.414,0.414,60.6,0,0,36.1,11.2);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(30.3,24.3,0.451,0.451,60.6,0,0,35.8,11.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},78).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ostrich_legMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:45,"clean":57});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_57 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(12).call(this.frame_57).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(9.3,24.6,0.412,0.412,-124.3,0,0,36,10.7);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(3.2,6.1,0.334,0.334,80.1,0,0,35.1,10.6);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(18.5,20.5,0.412,0.412,-124.3,0,0,36,10.8);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(10.1,14.4,0.441,0.441,56.6,0,0,36.1,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ostrich_legMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":105,"glowclean":106,"glowclean_loop":107,"final":108,"final_loop":109});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AAwCMQgOgdgNghQgLgcgQgXQgXgdgUgiQgSgfgggVIAAgCIgCAAIgCgBIAAgCIgBABIgCAAIABgBIgBgBQgIgMAAgFQAAgfAeAGQAIACAGADQArgfAOBAQAJAFAHAJIAFgBQAmgCAAArIAAAFQAKgCAKAHQASANAAAVIgOAYQAXACAAAXQAAAJgGAHQAPAEAEAEQAJAJAAAXQAAARgBAEQgHAQgeAAQgQAAgNgCg");
	this.shape.setTransform(12.1,14.2);

	this.instance = new lib.left_over_bubbles_sparse();
	this.instance.parent = this;
	this.instance.setTransform(17.9,17.5,0.54,0.54,120,0,0,46.1,10.1);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(15.4,16.5,0.776,0.776,-120,0,0,46.1,10.1);

	this.instance_2 = new lib.ostrich_legGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(9.9,21.6,1,1,0,0,0,16,31.8);

	this.glow = new lib.blueglowlegs();
	this.glow.parent = this;
	this.glow.setTransform(9.9,21.6,1,1,0,0,0,16,31.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1},{t:this.instance}]},7).to({state:[{t:this.instance_1},{t:this.instance}]},92).to({state:[{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},118).wait(78));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0.6,0,23,28.5);


(lib.ostrich_footMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":57});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
		/* 
		gameVars.footMud.push(this);
		if (gameVars.footMudClean == true) {this.alpha = 0;};*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_57 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(12).call(this.frame_57).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(17.9,10.8,0.412,0.412,-79.3,0,0,36,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(8,18.1,0.441,0.441,21.5,0,0,35.9,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ostrich_footMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":70,"glowclean":71,"glowclean_loop":72,"final":73,"final_loop":74});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AgBB7QABgMAIgIIACgEQgfAJghAFIgCAAQgLAGgQADQgBAAAAgBQgBAAAAAAQgBAAAAAAQgBABAAAAIgBABQgOgBgIgIIgBgBIAAAAIgDgDQgGgKAAgPQAAgLARgLQAUgNAhABIABAAIAEAAIAEAAIACgBQAcgDARgRIAAAAQAQgTAJgTIAAgDQACgTgEgSIACAAIgCgBIAAABIAAAAIgBgFQAAgMAHgCIAAgBQAAgJAIgGIABAAIAAAAIgBgDQAAgFAFAAQAFAAAAAFQAAAEgCABIAAAFIAAABIABAAQAAgFAFAAQABgCADgBIgBgCQAAgBABAAQAAgBAAgBQAAAAABAAQAAgBABAAIgBgBIgCgFIAAgBQgFgBgCgCIAAgFQAAgOAGABQABgDAEgBIACABQACgCAGgBQAGAAgBAHQAAAIgHAAIAAABIAAAEQAGACAAAGQAAAIgHAAIAAABIAAADQAGABAGAGIAAgCIAAgCQAAgUAUgBQAGAAAFACQgCAmAGAiQAGAdgIAcQgEAPgHANQgVAigbATIgFAEIgEACIgTABQgKAAgVAFgAAsg/IADAGIAAACQAEgFAGAAIACAAIAAgBIgCgIIgBAAQAAAEgFAAQAAAAgBAAQAAAAgBAAQAAgBgBAAQAAAAgBgBIgDAEg");
	this.shape.setTransform(12.1,12.4);

	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(18,15,0.25,0.25,131.8,0,0,50.2,5);

	this.instance_1 = new lib.ostrich_footGlow();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-3,9.9,1,1,0,0,0,24.7,18.2);

	this.glow = new lib.blueglowfeet();
	this.glow.parent = this;
	this.glow.setTransform(-3,9.9,1,1,0,0,0,24.7,18.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_1}]},2).to({state:[]},2).to({state:[{t:this.instance}]},7).to({state:[{t:this.instance}]},57).to({state:[{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},150).wait(81));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,24.1,24.7);


(lib.OstrichLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211});

	// Layer 3
	this.instance = new lib.ostrich_footMud_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(-21,34.8,1,1,0,0,0,13.2,12.8);

	this.instance_1 = new lib.ostrich_legMud_001_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-8.6,-8.6,1,1,0,0,0,11.8,14.2);

	this.instance_2 = new lib.ostrich_footMud_001_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(11.5,35.5,1,1,0,0,0,13.2,12.8);

	this.instance_3 = new lib.ostrich_legMud_001_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(6,-14.7,1,1,0,0,0,11.8,14.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},6).to({state:[]},203).to({state:[]},2).wait(2));

	// Layer 5
	this.frontfootmud = new lib.ostrich_footMud_001();
	this.frontfootmud.parent = this;
	this.frontfootmud.setTransform(5.3,36.4,1,1,0,0,0,13.2,12.8);

	this.frontlegmud = new lib.ostrich_legMud_001();
	this.frontlegmud.parent = this;
	this.frontlegmud.setTransform(-0.4,-13.4,1,1,0,0,0,11.8,14.2);

	this.instance_4 = new lib.OstrichLeg0004();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-20.5,-51.2,0.5,0.5);

	this.instance_5 = new lib.ostrich_legGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-2.9,-5.8,1.039,1.523,0,0,0,16.1,31.9);

	this.instance_6 = new lib.OstrichLeg0001();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-20.5,-51.2,0.5,0.5);

	this.instance_7 = new lib.OstrichLeg0002();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-20.5,-51.2,0.5,0.5);

	this.instance_8 = new lib.OstrichLeg0003();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-20.5,-51.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.frontlegmud},{t:this.frontfootmud}]}).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_6},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).to({state:[]},200).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-20.5,-51.2,47,114);


(lib.Ostrich = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:40,rest_stop:147,"clean":149,clean_stop:159,wet:161,wet_stop:173,excited:175,excited_stop:236,animalSound:238});

	// timeline functions:
	this.frame_38 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_147 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_159 = function() {
		/* stop();*/
	}
	this.frame_173 = function() {
		/* stop();*/
	}
	this.frame_236 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_275 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(38).call(this.frame_38).wait(109).call(this.frame_147).wait(12).call(this.frame_159).wait(14).call(this.frame_173).wait(63).call(this.frame_236).wait(39).call(this.frame_275).wait(1));

	// Ostrich Neck
	this.neck_bubbles = new lib.OstrichNeck_bubbles();
	this.neck_bubbles.parent = this;
	this.neck_bubbles.setTransform(306.3,187.2,0.785,0.785,0,0,0,3.9,31.6);

	this.timeline.addTween(cjs.Tween.get(this.neck_bubbles).to({_off:true},161).wait(115));

	// back bubbles
	this.back_bubbles = new lib.ostrichbackbubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(343.2,185.4,1,1,0,0,0,40.9,34.7);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).to({_off:true},161).wait(115));

	// Ostrich Tail
	this.tail_bubbles = new lib.OstrichTail_bubbles();
	this.tail_bubbles.parent = this;
	this.tail_bubbles.setTransform(388.7,177.3,0.785,0.785,0,0,0,2.6,-19.4);

	this.timeline.addTween(cjs.Tween.get(this.tail_bubbles).to({_off:true},161).wait(115));

	// Ostrich Leg
	this.feet_bubbles = new lib.OstrichLeg_bubbles();
	this.feet_bubbles.parent = this;
	this.feet_bubbles.setTransform(355.1,237.9,0.785,0.785);

	this.timeline.addTween(cjs.Tween.get(this.feet_bubbles).to({_off:true},161).wait(115));

	// Layer 6
	this.legs_bubbles = new lib.BackLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(344.2,235.4,0.785,0.785);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).to({_off:true},161).wait(115));

	// sparkle
	this.instance = new lib.sparkle();
	this.instance.parent = this;
	this.instance.setTransform(338,211.1,0.747,0.747);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(213).to({_off:false},0).to({_off:true},25).wait(38));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(390,154.7,0.294,0.235);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(220).to({_off:false},0).to({_off:true},18).wait(38));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(401.7,197.6,0.573,0.573);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(230).to({_off:false},0).to({_off:true},8).wait(38));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(390,181.6,0.366,0.366);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(225).to({_off:false},0).to({_off:true},13).wait(38));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(296.2,193.2,0.472,0.472);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(217).to({_off:false},0).to({_off:true},21).wait(38));

	// sparkle
	this.instance_5 = new lib.sparkle();
	this.instance_5.parent = this;
	this.instance_5.setTransform(252.4,115.7,0.168,0.168);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(232).to({_off:false},0).to({_off:true},6).wait(38));

	// sparkle
	this.instance_6 = new lib.sparkle();
	this.instance_6.parent = this;
	this.instance_6.setTransform(332.6,177.4,0.388,0.388);
	this.instance_6._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(222).to({_off:false},0).to({_off:true},16).wait(38));

	// Layer 3
	this.instance_7 = new lib.water_drops_011();
	this.instance_7.parent = this;
	this.instance_7.setTransform(344.8,185.3,0.5,0.5,0,0,180,92.4,49.1);
	this.instance_7._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(161).to({_off:false},0).to({_off:true},14).wait(101));

	// Wing
	this.instance_8 = new lib.Wing_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(315.3,193.5,0.887,0.887,0,0,0,-26.7,-3.5);

	this.instance_9 = new lib.OstrichWingspanNeckFeathers_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(322.2,190.7,0.426,0.426,0,28.7,-151.3,22.7,23.9);
	this.instance_9._off = true;

	this.instance_10 = new lib.OstrichHead_003_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(318.9,144.1,0.83,0.789,0,6.1,0,5.2,5.6);

	this.instance_11 = new lib.OstrichWingspanNeck_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(321.4,167,0.426,0.426,0,0,180,20.7,72.7);

	this.instance_12 = new lib.OstrichWingspanTorsoFeathers_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(338,197.5,0.253,0.239,-160.2,0,0,2.1,53.1);

	this.instance_13 = new lib.OstrichWingspanTorsoFeathers_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(307.9,190.8,0.419,0.346,0,-5.4,0,2.2,53.1);

	this.instance_14 = new lib.OstrichWingspanTorsoFeathers_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(311,188.9,0.518,0.467,0,0,0,9.4,52);

	this.instance_15 = new lib.OstrichWingspanWing_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(325.8,180,0.252,0.284,0,-6.8,149.2,11,102.4);

	this.instance_16 = new lib.OstrichWingspanWing_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(350,178.7,0.365,0.302,0,24.7,41,12.1,109);

	this.instance_17 = new lib.OstrichWingspanTorso_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(309.6,183.4,0.469,0.391,0,14,0,6.4,59.4);

	this.instance_18 = new lib.OstrichWingspanUpperLeftLeg();
	this.instance_18.parent = this;
	this.instance_18.setTransform(352.1,208.2,0.5,0.429,0,-20,-14.4,15.2,5.6);

	this.instance_19 = new lib.OstrichWingspanLeftLowerLeg();
	this.instance_19.parent = this;
	this.instance_19.setTransform(358.5,239,0.426,0.426,0,-0.1,0,21.9,7.8);

	this.instance_20 = new lib.NeckFeathers();
	this.instance_20.parent = this;
	this.instance_20.setTransform(309.1,185.7,0.754,0.785);

	this.instance_21 = new lib.OstrichTail();
	this.instance_21.parent = this;
	this.instance_21.setTransform(364,177.2,0.785,0.785,-27,0,0,2.6,-19.4);

	this.instance_22 = new lib.OstrichBodyFeathers();
	this.instance_22.parent = this;
	this.instance_22.setTransform(353.5,181.5,0.752,0.63,-1.9,0,0,49.9,26.2);

	this.instance_23 = new lib.OstrichBodyFeathers();
	this.instance_23.parent = this;
	this.instance_23.setTransform(336.7,189.4,1.074,0.828,-16.2,0,0,11.8,35.4);

	this.instance_24 = new lib.OstrichTorsoFeathers2();
	this.instance_24.parent = this;
	this.instance_24.setTransform(353,186.5,0.785,0.785,0,0,0,24.4,32.9);

	this.instance_25 = new lib.OstrichLegBUpper_001_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(350.4,208.4,0.785,0.785,0,-28.2,151.8,7.4,14.1);

	this.instance_26 = new lib.OstrichLegBLower_001_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(349,232.8,0.785,0.785,-19.5,0,0,34.6,0.6);

	this.instance_27 = new lib.OstrichFootB_001();
	this.instance_27.parent = this;
	this.instance_27.setTransform(346.2,262,0.765,0.765,0,0,0,18.6,5);

	this.instance_28 = new lib.eeeeeeeeee();
	this.instance_28.parent = this;
	this.instance_28.setTransform(339.7,201.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_8}]},8).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},6).to({state:[{t:this.instance_8}]},14).to({state:[{t:this.instance_8}]},24).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_8}]},28).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},6).to({state:[{t:this.instance_8}]},54).to({state:[{t:this.instance_8}]},10).to({state:[{t:this.instance_8}]},4).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_8},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_8}]},31).to({state:[{t:this.instance_8}]},8).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_8}]},6).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(10).to({regX:-31.3,regY:-3.4,rotation:-0.5,x:311.2,y:194.4},0).wait(2).to({regX:-26.9,regY:5.3,rotation:-0.7,x:315.3,y:202},0).wait(2).to({regY:0.7,rotation:-0.3,x:315.2,y:197.3},0).wait(2).to({regY:0.8,rotation:0,y:197.1},0).wait(4).to({regX:-26.7,regY:-3.5,x:315.3,y:193.5},0).wait(44).to({regY:-3.6,rotation:1.5,y:193.4},0).wait(2).to({regY:-3.7,rotation:-4.3},0).wait(2).to({regY:-3.4,rotation:-10,y:193.6},0).wait(2).to({regY:-3.5,rotation:-7.5,x:315.4,y:193.4},0).wait(2).to({regY:-3.4,rotation:-5,y:193.5},0).wait(2).to({regY:-3.5,rotation:-2.5,x:315.3},0).wait(1).to({rotation:0},0).wait(30).to({regX:-31.2,regY:-3.4,rotation:-0.5,x:311.2,y:194.4},0).wait(2).to({regX:-26.9,regY:5.2,rotation:-0.7,x:315.3,y:201.9},0).wait(2).to({regY:0.7,rotation:-0.3,x:315.2,y:197.3},0).wait(2).to({regY:0.8,rotation:0,y:197.1},0).wait(4).to({regX:-26.7,regY:-3.5,x:315.3,y:193.5},0).wait(76).to({regX:-26.8,scaleX:0.84,scaleY:0.94,rotation:-6.8,x:322.7,y:193.6},0).wait(2).to({regX:-26.7,scaleX:0.78,scaleY:0.99,rotation:-13.8,x:330.2,y:193.7},0).wait(2).to({regX:-26.9,regY:-3.4,scaleX:0.73,scaleY:1.03,rotation:-20.7,x:337.6,y:193.8},0).wait(2).to({scaleX:0.78,scaleY:0.89,x:334.1},0).to({_off:true},2).wait(39).to({_off:false,regX:-26.7,regY:-3.5,scaleX:0.89,rotation:0,x:315.3,y:193.5},0).wait(10).to({regX:-31.4,regY:-3.4,rotation:-0.5,x:311.1,y:194.4},0).wait(2).to({regX:-26.9,regY:5.4,rotation:-0.7,x:315.3,y:202.1},0).wait(2).to({regY:0.7,rotation:-0.3,x:315.2,y:197.3},0).wait(2).to({regY:0.8,rotation:0,y:197.1},0).wait(4).to({regX:-26.7,regY:-3.5,x:315.3,y:193.5},0).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(197).to({_off:false},0).wait(2).to({regX:22.8,skewX:0,skewY:-180,x:342.6,y:195.6},0).wait(2).to({regY:23.8,scaleY:0.32,skewX:23.3,skewY:-315,x:343,y:192.1},0).wait(2).to({regX:23.2,regY:23.6,scaleX:0.43,scaleY:0.36,skewX:15.5,skewY:-330,x:345.4,y:190},0).wait(2).to({regX:22.7,regY:23.7,scaleX:0.43,scaleY:0.39,skewX:7.8,skewY:-345.2,x:347.3,y:187.8},0).wait(2).to({regX:22.8,regY:23.8,scaleY:0.43,skewX:0,skewY:-360,x:349.4,y:185.7},0).to({_off:true},31).wait(38));

	// Ostrich Head
	this.instance_29 = new lib.OstrichHead_001_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(302.2,135.8,0.785,0.785,0,0,0,5.2,5.6);

	this.instance_30 = new lib.OstrichHead_003_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(298.6,136.1,0.785,0.788,0,0,-0.5,4.8,5.6);

	this.instance_31 = new lib.OstrichHead_005_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(297.6,136.4,0.784,0.786,0,-0.5,-0.8,5.2,5.6);

	this.instance_32 = new lib.OstrichHead_007_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(296,136.7,0.784,0.785,-0.8,0,0,5,5.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_29}]},8).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},6).to({state:[{t:this.instance_29}]},14).to({state:[{t:this.instance_29}]},24).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_30,p:{regX:4.8,scaleX:0.785,scaleY:0.788,rotation:0,skewY:-0.5,x:298.6,y:136.1,regY:5.6,skewX:0}}]},2).to({state:[{t:this.instance_31,p:{regY:5.6,scaleX:0.784,scaleY:0.786,rotation:0,skewX:-0.5,skewY:-0.8,x:297.6,y:136.4,regX:5.2}}]},2).to({state:[{t:this.instance_32,p:{regX:5,regY:5.6,scaleX:0.784,rotation:-0.8,skewX:0,skewY:0,x:296,y:136.7}}]},1).to({state:[{t:this.instance_31,p:{regY:5.5,scaleX:0.785,scaleY:0.785,rotation:-7.2,skewX:0,skewY:0,x:295.7,y:136.8,regX:5.2}}]},28).to({state:[{t:this.instance_30,p:{regX:5.2,scaleX:0.784,scaleY:0.784,rotation:-7.8,skewY:0,x:295.3,y:137.6,regY:5.6,skewX:0}}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},6).to({state:[{t:this.instance_29}]},54).to({state:[{t:this.instance_29}]},10).to({state:[{t:this.instance_29}]},4).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[]},2).to({state:[{t:this.instance_30,p:{regX:5.2,scaleX:0.785,scaleY:0.785,rotation:0,skewY:0,x:336.5,y:142.8,regY:5.6,skewX:0}}]},2).to({state:[{t:this.instance_32,p:{regX:5.1,regY:6,scaleX:0.785,rotation:0,skewX:-6.9,skewY:173.1,x:351,y:140.3}}]},2).to({state:[{t:this.instance_31,p:{regY:5.6,scaleX:0.784,scaleY:0.784,rotation:0,skewX:-6.8,skewY:173.2,x:353.3,y:138.1,regX:5.4}}]},2).to({state:[{t:this.instance_30,p:{regX:5.4,scaleX:0.784,scaleY:0.784,rotation:0,skewY:173.2,x:354.3,y:136.1,regY:5.5,skewX:-6.8}}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},31).to({state:[{t:this.instance_29}]},8).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},2).to({state:[{t:this.instance_29}]},6).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).wait(10).to({regY:5.5,scaleX:0.78,scaleY:0.78,rotation:-3.8,x:298.7,y:136.8},0).wait(2).to({regX:5.3,scaleX:0.79,scaleY:0.79,rotation:-7.9,x:295.2,y:137.8},0).wait(2).to({regX:5.2,regY:5.7,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:298.2,y:137.1},0).wait(2).to({regY:5.6,rotation:-1.8,x:300.4,y:136.3},0).wait(2).to({regX:1.8,regY:5.7,scaleX:0.79,scaleY:0.79,rotation:-0.3,x:299,y:136.1},0).wait(2).to({regX:5.2,regY:5.6,rotation:0,x:302.2,y:135.8},0).wait(46).to({regY:5.7,scaleY:0.79,skewX:0.3,x:302.5,y:135.7},0).wait(2).to({regY:5.6,scaleY:0.79,skewX:0.5,x:302.8,y:135.4},0).wait(2).to({scaleY:0.79,skewX:0.8,x:303.1,y:135.3},0).to({_off:true},2).wait(35).to({_off:false,regX:5.3,regY:5.5,scaleY:0.79,rotation:-7.9,skewX:0,x:295.2,y:137.8},0).wait(2).to({regX:5.2,regY:5.7,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:298.2,y:137.1},0).wait(2).to({regY:5.6,rotation:-1.8,x:300.4,y:136.3},0).wait(2).to({regX:0.2,regY:5.7,scaleX:0.79,scaleY:0.79,rotation:-0.3,x:297.8,y:136.1},0).wait(2).to({regX:5.2,regY:5.6,rotation:0,x:302.2,y:135.8},0).wait(76).to({x:305.3,y:139.7},0).wait(2).to({x:308.4,y:143.6},0).wait(2).to({x:311.4,y:147.5},0).to({_off:true},2).wait(10).to({_off:false,skewX:-6.9,skewY:173.1,x:355.4,y:134.1},0).wait(31).to({skewX:0,skewY:0,x:302.2,y:135.8},0).wait(10).to({regY:5.5,scaleX:0.78,scaleY:0.78,rotation:-3.8,x:298.7,y:136.8},0).wait(2).to({regX:5.3,scaleX:0.79,scaleY:0.79,rotation:-7.9,x:295.2,y:137.8},0).wait(2).to({regX:5.2,regY:5.7,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:298.2,y:137.1},0).wait(2).to({regY:5.6,rotation:-1.8,x:300.4,y:136.3},0).wait(2).to({regX:1.7,regY:5.7,scaleX:0.79,scaleY:0.79,rotation:-0.3,x:299,y:136.1},0).wait(2).to({regX:5.2,regY:5.6,rotation:0,x:302.2,y:135.8},0).wait(18));

	// Neck Feathers
	this.instance_33 = new lib.NeckFeathers();
	this.instance_33.parent = this;
	this.instance_33.setTransform(309.1,185.7,0.754,0.785);

	this.instance_34 = new lib.OstrichWingspanNeck_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(338,170,0.426,0.426,0,0,180,20.7,72.7);
	this.instance_34._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_33).wait(10).to({rotation:-0.5,y:186.3},0).wait(2).to({rotation:-0.7,y:186.5},0).wait(2).to({rotation:-0.3,y:186.2},0).wait(2).to({rotation:0,y:185.9},0).wait(2).to({y:185.7},0).wait(87).to({rotation:-0.5,y:186.3},0).wait(2).to({rotation:-0.7,y:186.5},0).wait(2).to({rotation:-0.3,y:186.2},0).wait(2).to({rotation:0,y:185.9},0).wait(2).to({y:185.7},0).wait(82).to({_off:true},2).wait(41).to({_off:false},0).wait(10).to({rotation:-0.5,y:186.3},0).wait(2).to({rotation:-0.7,y:186.5},0).wait(2).to({rotation:-0.3,y:186.2},0).wait(2).to({rotation:0,y:185.9},0).wait(2).to({y:185.7},0).wait(20));
	this.timeline.addTween(cjs.Tween.get(this.instance_34).wait(199).to({_off:false},0).wait(2).to({skewY:0,x:349.9,y:167.4},0).wait(2).to({x:350.8,y:165.3},0).wait(2).to({x:351.7,y:163.3},0).wait(2).to({x:352.6,y:161.3},0).to({_off:true},31).wait(38));

	// Ostrich Tail
	this.ostrich_tail = new lib.OstrichTail();
	this.ostrich_tail.parent = this;
	this.ostrich_tail.setTransform(388.7,177.3,0.785,0.785,0,0,0,2.6,-19.4);

	this.ostrich_tail_1 = new lib.OstrichTail_003();
	this.ostrich_tail_1.parent = this;
	this.ostrich_tail_1.setTransform(388.7,177.3,0.785,0.785,0,0,0,2.6,-19.4);

	this.ostrich_tail_2 = new lib.OstrichTail_002();
	this.ostrich_tail_2.parent = this;
	this.ostrich_tail_2.setTransform(388.7,177.3,0.785,0.785,0,0,0,2.6,-19.4);

	this.ostrich_tail_3 = new lib.OstrichTail_004();
	this.ostrich_tail_3.parent = this;
	this.ostrich_tail_3.setTransform(388.7,177.3,0.785,0.785,0,0,0,2.6,-19.4);

	this.ostrich_tail_4 = new lib.OstrichWingspanTorsoFeathers_1();
	this.ostrich_tail_4.parent = this;
	this.ostrich_tail_4.setTransform(338.8,192.4,0.338,0.308,0,0,0,59.7,52.4);
	this.ostrich_tail_4._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.ostrich_tail}]}).to({state:[{t:this.ostrich_tail}]},8).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},6).to({state:[{t:this.ostrich_tail}]},14).to({state:[{t:this.ostrich_tail}]},24).to({state:[{t:this.ostrich_tail_1}]},2).to({state:[{t:this.ostrich_tail_2}]},2).to({state:[{t:this.ostrich_tail_2}]},2).to({state:[{t:this.ostrich_tail_3}]},2).to({state:[{t:this.ostrich_tail_1}]},2).to({state:[{t:this.ostrich_tail}]},1).to({state:[{t:this.ostrich_tail}]},28).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},6).to({state:[{t:this.ostrich_tail}]},54).to({state:[{t:this.ostrich_tail}]},10).to({state:[{t:this.ostrich_tail}]},4).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[]},2).to({state:[{t:this.ostrich_tail_4}]},2).to({state:[{t:this.ostrich_tail_4}]},2).to({state:[{t:this.ostrich_tail_4}]},2).to({state:[{t:this.ostrich_tail_4}]},2).to({state:[{t:this.ostrich_tail_4}]},2).to({state:[{t:this.ostrich_tail}]},31).to({state:[{t:this.ostrich_tail}]},8).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},2).to({state:[{t:this.ostrich_tail}]},6).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.ostrich_tail).wait(10).to({regX:2.2,rotation:-0.5,x:388.4},0).wait(2).to({regX:2.6,rotation:-0.7,x:388.6,y:177.2},0).wait(2).to({regX:2.2,regY:-18.9,rotation:-0.3,x:388.4,y:177.6},0).wait(2).to({regX:2.7,regY:-19.3,rotation:0,x:388.7,y:177.3},0).wait(2).to({regX:2.6,regY:-19.4},0).wait(46).to({_off:true},2).wait(9).to({_off:false},0).wait(30).to({regX:2.2,rotation:-0.5,x:388.4},0).wait(2).to({regX:2.6,rotation:-0.7,x:388.6,y:177.2},0).wait(2).to({regX:2.2,regY:-18.9,rotation:-0.3,x:388.4,y:177.6},0).wait(2).to({regX:2.7,regY:-19.3,rotation:0,x:388.7,y:177.3},0).wait(2).to({regX:2.6,regY:-19.4},0).wait(78).to({regX:2.1,regY:-19.9,scaleX:0.78,scaleY:0.78,rotation:-8.8,x:385.1,y:177.4},0).wait(2).to({regX:2.6,regY:-19.4,rotation:-17.8,x:382.3,y:178},0).wait(2).to({scaleX:0.79,scaleY:0.79,rotation:-27,x:379,y:178.4},0).to({_off:true},2).wait(41).to({_off:false,rotation:0,x:388.7,y:177.3},0).wait(10).to({regX:2.2,rotation:-0.5,x:388.4},0).wait(2).to({regX:2.6,rotation:-0.7,x:388.6,y:177.2},0).wait(2).to({regX:2.2,regY:-18.9,rotation:-0.3,x:388.4,y:177.6},0).wait(2).to({regX:2.7,regY:-19.3,rotation:0,x:388.7,y:177.3},0).wait(2).to({regX:2.6,regY:-19.4},0).wait(20));
	this.timeline.addTween(cjs.Tween.get(this.ostrich_tail_4).wait(199).to({_off:false},0).wait(2).to({regX:59.6,regY:52.5,x:340.7,y:190.9},0).wait(2).to({regX:59.7,regY:52.4,x:342.6,y:189.3},0).wait(2).to({regX:59.6,x:344.6,y:187.7},0).wait(2).to({regX:59.7,regY:52.5,x:346.5,y:186.2},0).to({_off:true},31).wait(38));

	// Ostrich Body Feathers
	this.ostrich_torso = new lib.OstrichBodyFeathers1();
	this.ostrich_torso.parent = this;
	this.ostrich_torso.setTransform(347.4,183.9,0.752,0.63,-1.9,0,0,49.9,26.1);

	this.ostrich_torso_1 = new lib.OstrichWingspanTorsoFeathers_1();
	this.ostrich_torso_1.parent = this;
	this.ostrich_torso_1.setTransform(341.5,188.8,0.454,0.467,0,0,0,59.8,52.4);
	this.ostrich_torso_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.ostrich_torso).wait(10).to({rotation:-2.3,x:347.5,y:184.1},0).wait(2).to({regX:55.1,regY:25.8,rotation:-2.7,x:351.3,y:183.9},0).wait(2).to({regX:54.9,rotation:-2,x:351.8,y:183.6},0).wait(2).to({regX:55,regY:25.7,rotation:-1.8,x:351.9,y:183.3},0).wait(2).to({regX:54.9,x:351.6},0).wait(2).to({regX:49.9,regY:26.1,rotation:-1.9,x:347.4,y:183.9},0).wait(46).to({regX:50,rotation:-1.8,x:347.5,y:183.7},0).wait(2).to({regY:26,rotation:-1.9,y:183.4},0).wait(2).to({regX:50.1,rotation:-1.8,y:183.6},0).wait(2).to({regY:26.1,x:347.4,y:183.8},0).wait(2).to({regY:26},0).wait(1).to({regX:49.9,regY:26.1,rotation:-1.9,y:183.9},0).wait(30).to({rotation:-2.3,x:347.5,y:184.1},0).wait(2).to({regX:55.1,regY:25.8,rotation:-2.7,x:351.3,y:183.9},0).wait(2).to({regX:54.9,rotation:-2,x:351.8,y:183.6},0).wait(2).to({regX:55,regY:25.7,rotation:-1.8,x:351.9,y:183.3},0).wait(2).to({regX:54.9,x:351.6},0).wait(2).to({regX:49.9,regY:26.1,rotation:-1.9,x:347.4,y:183.9},0).wait(76).to({regX:48.9,regY:26.2,rotation:-1.8,x:349.8,y:183.2},0).wait(2).to({regX:49.9,regY:26.1,x:353.8,y:182.3},0).wait(2).to({rotation:-1.9,x:357.1,y:181.5},0).to({_off:true},2).wait(41).to({_off:false,x:347.4,y:183.9},0).wait(10).to({rotation:-2.3,x:347.5,y:184.1},0).wait(2).to({regX:55.1,regY:25.8,rotation:-2.7,x:351.3,y:183.9},0).wait(2).to({regX:54.9,rotation:-2,x:351.8,y:183.6},0).wait(2).to({regX:55,regY:25.7,rotation:-1.8,x:351.9,y:183.3},0).wait(2).to({regX:54.9,x:351.6},0).wait(2).to({regX:49.9,regY:26.1,rotation:-1.9,x:347.4,y:183.9},0).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.ostrich_torso_1).wait(199).to({_off:false},0).wait(2).to({x:342.5,y:188.4},0).wait(2).to({x:343.4,y:188.1},0).wait(2).to({x:344.4,y:187.7},0).wait(2).to({x:345.3,y:187.3},0).to({_off:true},31).wait(38));

	// Ostrich Body Feathers
	this.ostrich_roll1 = new lib.OstrichBodyFeathers();
	this.ostrich_roll1.parent = this;
	this.ostrich_roll1.setTransform(332.5,190,1.074,0.828,-16.2,0,0,11.8,35.6);

	this.ostrich_roll1_1 = new lib.OstrichWingspanWing_1();
	this.ostrich_roll1_1.parent = this;
	this.ostrich_roll1_1.setTransform(325.9,180,0.374,0.426,0,-5.2,149.2,10.8,102.4);
	this.ostrich_roll1_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.ostrich_roll1).wait(10).to({scaleX:1.07,scaleY:0.83,rotation:-16.8,x:332.4,y:190.4},0).wait(2).to({regX:11.6,scaleX:1.07,scaleY:0.83,rotation:-16.9,x:332.3,y:190.6},0).wait(2).to({regX:11.9,regY:35.9,scaleX:1.07,scaleY:0.83,rotation:-16.6,x:332.7,y:190.5},0).wait(2).to({regX:11.6,regY:35.5,rotation:-16.3,x:332.4,y:190.1},0).wait(2).to({regX:11.5,regY:35.6},0).wait(2).to({regX:11.8,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:332.5,y:190},0).wait(46).to({regX:11.3,regY:35.4,scaleX:1.07,scaleY:0.83,rotation:-16.1,x:331.9,y:189.7},0).wait(2).to({regX:11.8,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:332.4,y:189.4},0).wait(2).to({scaleX:1.07,scaleY:0.83,rotation:-16.1,y:189.6},0).wait(2).to({regX:11.3,x:331.9,y:189.9},0).wait(2).to({regX:11.8,x:332.4},0).wait(1).to({regY:35.6,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:332.5,y:190},0).wait(30).to({scaleX:1.07,scaleY:0.83,rotation:-16.8,x:332.4,y:190.4},0).wait(2).to({regX:11.6,scaleX:1.07,scaleY:0.83,rotation:-16.9,x:332.3,y:190.6},0).wait(2).to({regX:11.9,regY:35.9,scaleX:1.07,scaleY:0.83,rotation:-16.6,x:332.7,y:190.5},0).wait(2).to({regX:11.6,regY:35.5,rotation:-16.3,x:332.4,y:190.1},0).wait(2).to({regX:11.5,regY:35.6},0).wait(2).to({regX:11.8,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:332.5,y:190},0).wait(76).to({regY:35.7,scaleX:1.07,scaleY:0.83,rotation:-16.1,x:335,y:189.8},0).wait(2).to({regY:35.6,x:337.7,y:189.6},0).wait(2).to({regY:35.4,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:340.3,y:189.4},0).to({_off:true},2).wait(41).to({_off:false,regY:35.6,x:332.5,y:190},0).wait(10).to({scaleX:1.07,scaleY:0.83,rotation:-16.8,x:332.4,y:190.4},0).wait(2).to({regX:11.6,scaleX:1.07,scaleY:0.83,rotation:-16.9,x:332.3,y:190.6},0).wait(2).to({regX:11.9,regY:35.9,scaleX:1.07,scaleY:0.83,rotation:-16.6,x:332.7,y:190.5},0).wait(2).to({regX:11.6,regY:35.5,rotation:-16.3,x:332.4,y:190.1},0).wait(2).to({regX:11.5,regY:35.6},0).wait(2).to({regX:11.8,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:332.5,y:190},0).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.ostrich_roll1_1).wait(199).to({_off:false},0).wait(2).to({regX:10.7,regY:102.5,scaleX:0.41,skewX:-3.8,skewY:156.9,x:327.6,y:179.4},0).wait(2).to({scaleX:0.44,skewX:-2.5,skewY:164.7,x:329.2,y:178.7},0).wait(2).to({regX:10.8,regY:102.1,scaleX:0.47,skewX:-1.3,skewY:172.4,x:330.9,y:178},0).wait(2).to({regX:10.5,regY:102.5,scaleX:0.51,skewX:0,skewY:180,x:332.5,y:177.4},0).to({_off:true},31).wait(38));

	// Ostrich Torso Feathers 2
	this.ostrich_roll2 = new lib.OstrichTorsoFeathers2();
	this.ostrich_roll2.parent = this;
	this.ostrich_roll2.setTransform(351.9,186.5,0.785,0.785,0,0,0,24.6,32.8);

	this.ostrich_roll2_1 = new lib.OstrichWingspanWing_1();
	this.ostrich_roll2_1.parent = this;
	this.ostrich_roll2_1.setTransform(360.2,180.5,0.44,0.426,0,24.7,41,12.2,109);
	this.ostrich_roll2_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.ostrich_roll2).wait(10).to({rotation:-0.5,y:186.7},0).wait(2).to({rotation:-0.7,y:186.8},0).wait(2).to({rotation:-0.3,y:186.6},0).wait(2).to({regX:19.4,regY:37.9,rotation:0,x:347.8,y:190.6},0).wait(2).to({regX:24.6,regY:32.8,x:351.9,y:186.5},0).wait(48).to({y:186.3},0).wait(2).to({regY:32.9,y:186.1},0).wait(2).to({regY:32.8,y:186.2},0).wait(2).to({y:186.3},0).wait(2).to({regY:32.9,y:186.4},0).wait(1).to({regY:32.8,y:186.5},0).wait(30).to({rotation:-0.5,y:186.7},0).wait(2).to({rotation:-0.7,y:186.8},0).wait(2).to({rotation:-0.3,y:186.6},0).wait(2).to({regX:19.4,regY:37.9,rotation:0,x:347.8,y:190.6},0).wait(2).to({regX:24.6,regY:32.8,x:351.9,y:186.5},0).wait(78).to({regX:24.4,x:353.4},0).wait(2).to({regY:32.9,x:355},0).wait(2).to({regX:24.6,x:356.8},0).to({_off:true},2).wait(41).to({_off:false,regY:32.8,x:351.9},0).wait(10).to({rotation:-0.5,y:186.7},0).wait(2).to({rotation:-0.7,y:186.8},0).wait(2).to({rotation:-0.3,y:186.6},0).wait(2).to({regX:19.3,regY:38,rotation:0,x:347.7,y:190.6},0).wait(2).to({regX:24.6,regY:32.8,x:351.9,y:186.5},0).wait(20));
	this.timeline.addTween(cjs.Tween.get(this.ostrich_roll2_1).wait(199).to({_off:false},0).wait(2).to({regY:109.1,scaleX:0.46,scaleY:0.43,skewX:17,skewY:29.3},0).wait(2).to({regX:12.1,regY:109,scaleX:0.47,scaleY:0.43,skewX:9.5,skewY:17.6,x:360.3},0).wait(2).to({regY:108.9,scaleX:0.49,skewX:2,skewY:6},0).wait(2).to({regX:12.2,regY:109,scaleX:0.51,rotation:-5.5,skewX:0,skewY:0,x:360.2},0).to({_off:true},31).wait(38));

	// Ostrich Torso Feathers 3
	this.ostrich_roll3 = new lib.OstrichTorsoFeathers3();
	this.ostrich_roll3.parent = this;
	this.ostrich_roll3.setTransform(366.8,184.6,0.785,0.785,0,0,0,22.2,30.1);

	this.ostrich_roll3_1 = new lib.OstrichWingspanTorso_1();
	this.ostrich_roll3_1.parent = this;
	this.ostrich_roll3_1.setTransform(343.5,186.1,0.426,0.426,0,0,0,78.2,60.8);
	this.ostrich_roll3_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.ostrich_roll3).wait(10).to({rotation:-0.5,x:367,y:184.7},0).wait(2).to({regX:22.4,regY:30,rotation:-0.7,x:366.9},0).wait(2).to({regY:30.1,rotation:-0.3,x:366.8,y:184.6},0).wait(2).to({regY:30,rotation:0,y:184.7},0).wait(2).to({regY:30.1,y:184.6},0).wait(2).to({regX:22.2},0).wait(46).to({y:184.4},0).wait(2).to({y:184.2},0).wait(2).to({y:184.3},0).wait(2).to({y:184.4},0).wait(2).to({y:184.5},0).wait(1).to({y:184.6},0).wait(30).to({rotation:-0.5,x:367,y:184.7},0).wait(2).to({regX:22.4,regY:30,rotation:-0.7,x:366.9},0).wait(2).to({regY:30.1,rotation:-0.3,x:366.8,y:184.6},0).wait(2).to({regY:30,rotation:0,y:184.7},0).wait(2).to({regY:30.1,y:184.6},0).wait(2).to({regX:22.2},0).wait(76).to({x:365.5,y:184.7},0).wait(2).to({x:364.2,y:184.8},0).wait(2).to({x:362.9,y:184.9},0).to({_off:true},2).wait(41).to({_off:false,x:366.8,y:184.6},0).wait(10).to({rotation:-0.5,x:367,y:184.7},0).wait(2).to({regX:22.4,regY:30,rotation:-0.7,x:366.9},0).wait(2).to({regY:30.1,rotation:-0.3,x:366.8,y:184.6},0).wait(2).to({regY:30,rotation:0,y:184.7},0).wait(2).to({regY:30.1,y:184.6},0).wait(2).to({regX:22.2},0).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.ostrich_roll3_1).wait(199).to({_off:false},0).wait(2).to({y:186.4},0).wait(2).to({y:186.6},0).wait(2).to({y:186.8},0).wait(2).to({y:187},0).to({_off:true},31).wait(38));

	// Body
	this.instance_35 = new lib.Body_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(349.4,184.4,0.785,0.785);

	this.instance_36 = new lib.OstrichWingspanLegFeathers();
	this.instance_36.parent = this;
	this.instance_36.setTransform(349.9,213.9,0.426,0.426,0,0,180,19.8,7.4);
	this.instance_36._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_35).wait(10).to({rotation:-0.5,y:184.6},0).wait(2).to({rotation:-0.7,y:184.7},0).wait(2).to({rotation:-0.3,y:184.6},0).wait(2).to({rotation:0,y:184.5},0).wait(2).to({y:184.4},0).wait(48).to({y:184.2},0).wait(2).to({y:184},0).wait(2).to({y:184.1},0).wait(2).to({y:184.2},0).wait(2).to({y:184.3},0).wait(1).to({y:184.4},0).wait(30).to({rotation:-0.5,y:184.6},0).wait(2).to({rotation:-0.7,y:184.7},0).wait(2).to({rotation:-0.3,y:184.6},0).wait(2).to({rotation:0,y:184.5},0).wait(2).to({y:184.4},0).wait(78).to({scaleX:0.72},0).wait(2).to({scaleX:0.66},0).wait(2).to({scaleX:0.59},0).to({_off:true},2).wait(41).to({_off:false,scaleX:0.79},0).wait(10).to({rotation:-0.5,y:184.6},0).wait(2).to({rotation:-0.7,y:184.7},0).wait(2).to({rotation:-0.3,y:184.6},0).wait(2).to({rotation:0,y:184.5},0).wait(2).to({y:184.4},0).wait(20));
	this.timeline.addTween(cjs.Tween.get(this.instance_36).wait(199).to({_off:false},0).wait(2).to({x:352.8,y:213.7},0).wait(2).to({regX:19.7,x:355.7,y:213.4},0).wait(2).to({regX:19.8,x:358.5,y:213.1},0).wait(2).to({regX:19.7,x:361.5,y:212.9},0).to({_off:true},31).wait(38));

	// Ostrich Neck
	this.ostrich_neck = new lib.OstrichNeck();
	this.ostrich_neck.parent = this;
	this.ostrich_neck.setTransform(306.3,187.2,0.785,0.785,0,0,0,3.9,31.6);

	this.ostrich_neck_1 = new lib.OstrichWingspanLegFeathers();
	this.ostrich_neck_1.parent = this;
	this.ostrich_neck_1.setTransform(336.4,213.5,0.426,0.44,0,14.3,0,19.8,7.4);
	this.ostrich_neck_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.ostrich_neck).wait(10).to({regX:3.8,scaleX:0.78,scaleY:0.78,rotation:-3.8,x:306.2,y:187.7},0).wait(2).to({regX:3.9,scaleX:0.79,scaleY:0.79,rotation:-7.9,y:188.2},0).wait(2).to({regX:4,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:306.4,y:187.8},0).wait(2).to({regX:3.9,rotation:-1.8,x:306.3,y:187.5},0).wait(2).to({regX:3.8,regY:31.4,scaleX:0.79,scaleY:0.79,rotation:-0.3,y:187.2},0).wait(2).to({regX:3.9,regY:31.6,rotation:0},0).wait(46).to({regX:3.8,scaleY:0.79,skewX:0.3,x:306.2},0).wait(2).to({regX:3.9,regY:31.4,scaleY:0.79,skewX:0.5,x:306.4,y:187},0).wait(2).to({regX:3.8,regY:31.6,scaleY:0.79,skewX:0.8,x:306.3,y:187.2},0).wait(2).to({regX:6.5,regY:31.5,scaleX:0.78,scaleY:0.79,skewX:-3.5,skewY:-4,x:308.3,y:187.1},0).wait(2).to({regX:3.9,regY:31.6,scaleY:0.79,rotation:-6.3,skewX:0,skewY:0,x:306.2,y:187.3},0).wait(1).to({scaleX:0.79,rotation:-7.2},0).wait(30).to({regX:4,scaleX:0.78,scaleY:0.78,rotation:-7.8,x:306.3,y:188},0).wait(2).to({regX:3.9,scaleX:0.79,scaleY:0.79,rotation:-7.9,x:306.2,y:188.2},0).wait(2).to({regX:4,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:306.4,y:187.8},0).wait(2).to({regX:3.9,rotation:-1.8,x:306.3,y:187.5},0).wait(2).to({regX:3.8,regY:31.4,scaleX:0.79,scaleY:0.79,rotation:-0.3,y:187.2},0).wait(2).to({regX:3.9,regY:31.6,rotation:0},0).wait(76).to({scaleX:0.84,scaleY:0.74,skewX:-1.3,skewY:3.8,x:311.1,y:188.1},0).wait(2).to({regY:31.7,scaleX:0.9,scaleY:0.69,skewX:-2.6,skewY:7.5,x:316,y:189},0).wait(2).to({regX:4.3,regY:30.4,scaleX:0.95,scaleY:0.64,skewX:-4.1,skewY:11.5,x:320.9,y:189.8},0).to({_off:true},2).wait(41).to({_off:false,regX:3.9,regY:31.6,scaleX:0.79,scaleY:0.79,skewX:0,skewY:0,x:306.3,y:187.2},0).wait(10).to({regX:3.8,scaleX:0.78,scaleY:0.78,rotation:-3.8,x:306.2,y:187.7},0).wait(2).to({regX:3.9,scaleX:0.79,scaleY:0.79,rotation:-7.9,y:188.2},0).wait(2).to({regX:4,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:306.4,y:187.8},0).wait(2).to({regX:3.9,rotation:-1.8,x:306.3,y:187.5},0).wait(2).to({regX:3.8,regY:31.4,scaleX:0.79,scaleY:0.79,rotation:-0.3,y:187.2},0).wait(2).to({regX:3.9,regY:31.6,rotation:0},0).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.ostrich_neck_1).wait(199).to({_off:false},0).wait(2).to({regX:19.9,scaleY:0.44,skewX:10.6,x:334.7},0).wait(2).to({regY:7.5,scaleY:0.43,skewX:7,x:333},0).wait(2).to({regY:7.4,scaleY:0.43,skewX:3.5,x:331.4},0).wait(2).to({scaleY:0.43,skewX:0,x:329.7},0).to({_off:true},31).wait(38));

	// Upper Leg
	this.ostrich_frontleg = new lib.OstrichLeg();
	this.ostrich_frontleg.parent = this;
	this.ostrich_frontleg.setTransform(355.1,237.9,0.785,0.785);

	this.ostrich_frontleg_1 = new lib.OstrichWingspanUpperLeftLeg();
	this.ostrich_frontleg_1.parent = this;
	this.ostrich_frontleg_1.setTransform(348.3,208.4,0.426,0.426,-10.2,0,0,15.1,5.5);
	this.ostrich_frontleg_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.ostrich_frontleg).wait(191).to({scaleX:0.75,x:355.5},0).wait(2).to({scaleX:0.72,rotation:-0.1,x:355.9},0).wait(2).to({scaleX:0.69,rotation:-0.3,x:356.4},0).to({_off:true},2).wait(41).to({_off:false,scaleX:0.79,rotation:0,x:355.1},0).wait(38));
	this.timeline.addTween(cjs.Tween.get(this.ostrich_frontleg_1).wait(199).to({_off:false},0).wait(2).to({regX:15.2,regY:5.6,rotation:-5.5,x:351.8},0).wait(2).to({regY:6.4,rotation:-1,x:355.2,y:208.5},0).wait(2).to({regX:14.9,regY:5.2,rotation:3.3,x:358.6,y:207.9},0).wait(2).to({regX:16,regY:5.4,rotation:8,x:362.2,y:208},0).to({_off:true},31).wait(38));

	// Front Foot
	this.instance_37 = new lib.OstrichWingspanLeftLowerLeg();
	this.instance_37.parent = this;
	this.instance_37.setTransform(351.2,239.7,0.426,0.429,0,-6.3,0,21.9,7.8);
	this.instance_37._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_37).wait(199).to({_off:false},0).wait(2).to({scaleY:0.43,skewX:-4.6,x:352.3,y:239.8},0).wait(2).to({regY:7.7,scaleY:0.43,skewX:-3,x:353.4,y:239.7},0).wait(2).to({regX:22,skewX:-1.5,x:354.5},0).wait(2).to({regX:21.9,regY:7.8,scaleY:0.43,skewX:0,x:355.5},0).to({_off:true},31).wait(38));

	// Lower Leg
	this.instance_38 = new lib.OstrichWingspanUpperRightLeg_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(335,212.9,0.441,0.424,0,6.2,-8,11.4,13.7);
	this.instance_38._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_38).wait(199).to({_off:false},0).wait(2).to({regX:11.6,scaleX:0.44,skewX:2.5,x:333.3},0).wait(2).to({regX:11.5,scaleX:0.43,scaleY:0.43,skewX:-1,x:331.6,y:212.8},0).wait(2).to({regX:11.3,regY:13.8,scaleX:0.43,skewX:-4.5,skewY:-8.1,x:329.8,y:212.9},0).wait(2).to({regX:11.6,regY:13.7,scaleX:0.43,scaleY:0.43,rotation:-8.3,skewX:0,skewY:0,x:328.2},0).to({_off:true},31).wait(38));

	// Back Upper Leg
	this.ostrich_hindleg = new lib.BackLeg();
	this.ostrich_hindleg.parent = this;
	this.ostrich_hindleg.setTransform(344.2,235.4,0.785,0.785);

	this.timeline.addTween(cjs.Tween.get(this.ostrich_hindleg).wait(191).to({scaleX:0.75,scaleY:0.78,rotation:-2.8,x:345.3},0).wait(2).to({scaleX:0.71,rotation:-5.8,x:346.2},0).wait(2).to({scaleX:0.67,scaleY:0.79,rotation:-8.7,x:347.3,y:235.3},0).to({_off:true},2).wait(41).to({_off:false,scaleX:0.79,rotation:0,x:344.2,y:235.4},0).wait(38));

	// Back Lower Leg
	this.instance_39 = new lib.OstrichWingspanLowerRightLeg();
	this.instance_39.parent = this;
	this.instance_39.setTransform(337.3,258.1,0.426,0.426,0,2.2,0,20.9,49.8);
	this.instance_39._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_39).wait(199).to({_off:false},0).wait(2).to({skewX:1.5},0).wait(2).to({skewX:1},0).wait(2).to({skewX:0.5},0).wait(2).to({regX:21.1,skewX:0,x:337.4},0).to({_off:true},31).wait(38));

	// Layer 10
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F2F2F2").s().p("AALAWQAAAAgBAAQAAAAAAgBQAAAAAAAAQgBgBAAAAIAAgCIAAAAQgBgEABgCIABgCQAAgBABAAQAAgBAAAAQABAAAAgBQABAAAAAAQACgBADABIACABIADADIAAAFQgBAEgCABIgGABQAEAEAEgCQADgEAAgJQAAgKgJgLQgJgLgKgCQgJgBgJACIgFABIgCAAIAAgBQgBAAAAAAIABgBIAHgCQAKgDALACQALABAKAPQALAOgDALQgDALgDAAIAAAAIgFACQgEAAgDgGgAAOAKIgCACQgCADABADIABABQAIACAAgEQABgFgCgBIgDgBIgCAAg");
	this.shape.setTransform(343.3,201.3);

	this.instance_40 = new lib.ToucanTween8s1("synched",0);
	this.instance_40.parent = this;
	this.instance_40.setTransform(343.3,201.3);

	this.instance_41 = new lib.eeeeeeeeee("synched",0);
	this.instance_41.parent = this;
	this.instance_41.setTransform(343.3,201.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape}]},26).to({state:[{t:this.shape}]},14).to({state:[{t:this.shape}]},81).to({state:[{t:this.shape}]},54).to({state:[{t:this.shape}]},10).to({state:[{t:this.instance_40}]},4).to({state:[{t:this.instance_40}]},2).to({state:[{t:this.instance_40}]},2).to({state:[{t:this.instance_41}]},2).to({state:[]},2).to({state:[{t:this.shape}]},41).to({state:[{t:this.shape}]},26).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.shape).wait(185).to({_off:true},4).wait(49).to({_off:false},0).wait(38));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(281.3,119.2,449.3,175.5);


(lib.ostrich = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// legGlow
	this.legGlow = new lib.ostrich_legGlow();
	this.legGlow.parent = this;
	this.legGlow.setTransform(212.8,184,1,1,0,0,0,16.6,20.1);
	this.legGlow.alpha = 0;
	this.legGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.legGlow.cache(-5,-2,43,68);

	this.timeline.addTween(cjs.Tween.get(this.legGlow).wait(1));

	// footGlow
	this.footGlow = new lib.ostrich_footGlow();
	this.footGlow.parent = this;
	this.footGlow.setTransform(204.4,238.9,1,1,0,0,0,27.5,16.3);
	this.footGlow.alpha = 0;
	this.footGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.footGlow.cache(-9,-4,68,44);

	this.timeline.addTween(cjs.Tween.get(this.footGlow).wait(1));

	// backGlow
	this.backGlow = new lib.ostrich_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(208,108.3,1,1,0,0,0,48.6,17.2);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.backGlow.cache(-5,0,113,41);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// neckGlow
	this.neckGlow = new lib.ostrich_neckGlow();
	this.neckGlow.parent = this;
	this.neckGlow.setTransform(142.1,98.9,1,1,0,0,0,12.1,42.5);
	this.neckGlow.alpha = 0;
	this.neckGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.neckGlow.cache(-4,5,26,83);

	this.timeline.addTween(cjs.Tween.get(this.neckGlow).wait(1));

	// tailGlow
	this.tailGlow = new lib.ostrich_tailGlow();
	this.tailGlow.parent = this;
	this.tailGlow.setTransform(272.4,134.2,1,1,0,0,0,20.4,19.7);
	this.tailGlow.alpha = 0;
	this.tailGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.tailGlow.cache(-4,-4,49,47);

	this.timeline.addTween(cjs.Tween.get(this.tailGlow).wait(1));

	// tummy
	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(181,156.9,0.614,1.587,92.2);

	this.timeline.addTween(cjs.Tween.get(this.tummy).wait(1));

	// leg1
	this.leg1 = new lib.invisiblebox();
	this.leg1.parent = this;
	this.leg1.setTransform(215.1,200.7,1.086,0.812,94.6);

	this.timeline.addTween(cjs.Tween.get(this.leg1).wait(1));

	// foot1
	this.foot1 = new lib.invisiblebox();
	this.foot1.parent = this;
	this.foot1.setTransform(202.1,243.3,1.525,0.716,7.3);

	this.timeline.addTween(cjs.Tween.get(this.foot1).wait(1));

	// tail
	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(274.8,133.6,0.921,0.966,2.8);

	this.timeline.addTween(cjs.Tween.get(this.tail).wait(1));

	// back
	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(204.3,107.1,2.42,0.862,-3.3);

	this.timeline.addTween(cjs.Tween.get(this.back).wait(1));

	// beak
	this.beak = new lib.invisiblebox();
	this.beak.parent = this;
	this.beak.setTransform(125.6,58.1,0.549,0.35);

	this.timeline.addTween(cjs.Tween.get(this.beak).wait(1));

	// neck
	this.neck = new lib.invisiblebox();
	this.neck.parent = this;
	this.neck.setTransform(138.2,103.9,0.531,1.721);

	this.timeline.addTween(cjs.Tween.get(this.neck).wait(1));

	// main
	this.main = new lib.Ostrich();
	this.main.parent = this;
	this.main.setTransform(200.4,155.9,1.385,1.385,0,0,0,345.3,203.6);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.ostrich, new cjs.Rectangle(111.6,43.1,189.4,228.4), null);


// stage content:
(lib.MWostrich = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wrongAnswer":0,"rest":40,"clean":149,"wet":161,"excited":175,"animalSound":238});

	// timeline functions:
	this.frame_6 = function() {
		playSound("sesame_murray_ostrich_00_intro_squawk");
	}
	this.frame_38 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_56 = function() {
		playSound("sesame_murray_ostrich_03_zoom_squawk");
	}
	this.frame_103 = function() {
		playSound("sesame_murray_ostrich_00_intro_squawk");
	}
	this.frame_147 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_159 = function() {
		/* stop();*/
	}
	this.frame_173 = function() {
		/* stop();*/
	}
	this.frame_191 = function() {
		playSound("sesame_murray_ostrich_00_intro_squawk");
	}
	this.frame_213 = function() {
		playSound("GleamAfterDrying5wav");
	}
	this.frame_236 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_275 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(6).call(this.frame_6).wait(32).call(this.frame_38).wait(18).call(this.frame_56).wait(47).call(this.frame_103).wait(44).call(this.frame_147).wait(12).call(this.frame_159).wait(14).call(this.frame_173).wait(18).call(this.frame_191).wait(22).call(this.frame_213).wait(23).call(this.frame_236).wait(39).call(this.frame_275).wait(1));

	// Ostrich Neck
	this.instance_42 = new lib.OstrichNeck_bubbles();
	this.instance_42.parent = this;
	this.instance_42.setTransform(306.3,187.2,0.785,0.785,0,0,0,3.9,31.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true},161).wait(115));

	// back bubbles
	this.instance_43 = new lib.ostrichbackbubbles();
	this.instance_43.parent = this;
	this.instance_43.setTransform(343.2,185.4,1,1,0,0,0,40.9,34.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_43).to({_off:true},161).wait(115));

	// Ostrich Tail
	this.instance_44 = new lib.OstrichTail_bubbles();
	this.instance_44.parent = this;
	this.instance_44.setTransform(388.7,177.3,0.785,0.785,0,0,0,2.6,-19.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_44).to({_off:true},161).wait(115));

	// Ostrich Leg
	this.instance_45 = new lib.OstrichLeg_bubbles();
	this.instance_45.parent = this;
	this.instance_45.setTransform(355.1,237.9,0.785,0.785);

	this.timeline.addTween(cjs.Tween.get(this.instance_45).to({_off:true},161).wait(115));

	// Layer 6
	this.instance_46 = new lib.BackLeg_bubbles();
	this.instance_46.parent = this;
	this.instance_46.setTransform(344.2,235.4,0.785,0.785);

	this.timeline.addTween(cjs.Tween.get(this.instance_46).to({_off:true},161).wait(115));

	// sparkle
	this.instance_47 = new lib.sparkle();
	this.instance_47.parent = this;
	this.instance_47.setTransform(338,211.1,0.747,0.747);
	this.instance_47._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_47).wait(213).to({_off:false},0).to({_off:true},25).wait(38));

	// sparkle
	this.instance_48 = new lib.sparkle();
	this.instance_48.parent = this;
	this.instance_48.setTransform(390,154.7,0.294,0.235);
	this.instance_48._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_48).wait(220).to({_off:false},0).to({_off:true},18).wait(38));

	// sparkle
	this.instance_49 = new lib.sparkle();
	this.instance_49.parent = this;
	this.instance_49.setTransform(401.7,197.6,0.573,0.573);
	this.instance_49._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_49).wait(230).to({_off:false},0).to({_off:true},8).wait(38));

	// sparkle
	this.instance_50 = new lib.sparkle();
	this.instance_50.parent = this;
	this.instance_50.setTransform(390,181.6,0.366,0.366);
	this.instance_50._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_50).wait(225).to({_off:false},0).to({_off:true},13).wait(38));

	// sparkle
	this.instance_51 = new lib.sparkle();
	this.instance_51.parent = this;
	this.instance_51.setTransform(296.2,193.2,0.472,0.472);
	this.instance_51._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_51).wait(217).to({_off:false},0).to({_off:true},21).wait(38));

	// sparkle
	this.instance_52 = new lib.sparkle();
	this.instance_52.parent = this;
	this.instance_52.setTransform(252.4,115.7,0.168,0.168);
	this.instance_52._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_52).wait(232).to({_off:false},0).to({_off:true},6).wait(38));

	// sparkle
	this.instance_53 = new lib.sparkle();
	this.instance_53.parent = this;
	this.instance_53.setTransform(332.6,177.4,0.388,0.388);
	this.instance_53._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_53).wait(222).to({_off:false},0).to({_off:true},16).wait(38));

	// Layer 3
	this.instance_54 = new lib.water_drops_011();
	this.instance_54.parent = this;
	this.instance_54.setTransform(344.8,185.3,0.5,0.5,0,0,180,92.4,49.1);
	this.instance_54._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_54).wait(161).to({_off:false},0).to({_off:true},14).wait(101));

	// Wing
	this.instance_55 = new lib.Wing_1();
	this.instance_55.parent = this;
	this.instance_55.setTransform(315.3,193.5,0.887,0.887,0,0,0,-26.7,-3.5);

	this.instance_56 = new lib.OstrichWingspanNeckFeathers_1();
	this.instance_56.parent = this;
	this.instance_56.setTransform(322.2,190.7,0.426,0.426,0,28.7,-151.3,22.7,23.9);
	this.instance_56._off = true;

	this.instance_57 = new lib.OstrichHead_003_1();
	this.instance_57.parent = this;
	this.instance_57.setTransform(318.9,144.1,0.83,0.789,0,6.1,0,5.2,5.6);

	this.instance_58 = new lib.OstrichWingspanNeck_1();
	this.instance_58.parent = this;
	this.instance_58.setTransform(321.4,167,0.426,0.426,0,0,180,20.7,72.7);

	this.instance_59 = new lib.OstrichWingspanTorsoFeathers_1();
	this.instance_59.parent = this;
	this.instance_59.setTransform(338,197.5,0.253,0.239,-160.2,0,0,2.1,53.1);

	this.instance_60 = new lib.OstrichWingspanTorsoFeathers_1();
	this.instance_60.parent = this;
	this.instance_60.setTransform(307.9,190.8,0.419,0.346,0,-5.4,0,2.2,53.1);

	this.instance_61 = new lib.OstrichWingspanTorsoFeathers_1();
	this.instance_61.parent = this;
	this.instance_61.setTransform(311,188.9,0.518,0.467,0,0,0,9.4,52);

	this.instance_62 = new lib.OstrichWingspanWing_1();
	this.instance_62.parent = this;
	this.instance_62.setTransform(325.8,180,0.252,0.284,0,-6.8,149.2,11,102.4);

	this.instance_63 = new lib.OstrichWingspanWing_1();
	this.instance_63.parent = this;
	this.instance_63.setTransform(350,178.7,0.365,0.302,0,24.7,41,12.1,109);

	this.instance_64 = new lib.OstrichWingspanTorso_1();
	this.instance_64.parent = this;
	this.instance_64.setTransform(309.6,183.4,0.469,0.391,0,14,0,6.4,59.4);

	this.instance_65 = new lib.OstrichWingspanUpperLeftLeg();
	this.instance_65.parent = this;
	this.instance_65.setTransform(352.1,208.2,0.5,0.429,0,-20,-14.4,15.2,5.6);

	this.instance_66 = new lib.OstrichWingspanLeftLowerLeg();
	this.instance_66.parent = this;
	this.instance_66.setTransform(358.5,239,0.426,0.426,0,-0.1,0,21.9,7.8);

	this.instance_67 = new lib.NeckFeathers();
	this.instance_67.parent = this;
	this.instance_67.setTransform(309.1,185.7,0.754,0.785);

	this.instance_68 = new lib.OstrichTail();
	this.instance_68.parent = this;
	this.instance_68.setTransform(364,177.2,0.785,0.785,-27,0,0,2.6,-19.4);

	this.instance_69 = new lib.OstrichBodyFeathers();
	this.instance_69.parent = this;
	this.instance_69.setTransform(353.5,181.5,0.752,0.63,-1.9,0,0,49.9,26.2);

	this.instance_70 = new lib.OstrichBodyFeathers();
	this.instance_70.parent = this;
	this.instance_70.setTransform(336.7,189.4,1.074,0.828,-16.2,0,0,11.8,35.4);

	this.instance_71 = new lib.OstrichTorsoFeathers2();
	this.instance_71.parent = this;
	this.instance_71.setTransform(353,186.5,0.785,0.785,0,0,0,24.4,32.9);

	this.instance_72 = new lib.OstrichLegBUpper_001_1();
	this.instance_72.parent = this;
	this.instance_72.setTransform(350.4,208.4,0.785,0.785,0,-28.2,151.8,7.4,14.1);

	this.instance_73 = new lib.OstrichLegBLower_001_1();
	this.instance_73.parent = this;
	this.instance_73.setTransform(349,232.8,0.785,0.785,-19.5,0,0,34.6,0.6);

	this.instance_74 = new lib.OstrichFootB_001();
	this.instance_74.parent = this;
	this.instance_74.setTransform(346.2,262,0.765,0.765,0,0,0,18.6,5);

	this.instance_75 = new lib.eeeeeeeeee();
	this.instance_75.parent = this;
	this.instance_75.setTransform(339.7,201.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_55}]}).to({state:[{t:this.instance_55}]},8).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},6).to({state:[{t:this.instance_55}]},14).to({state:[{t:this.instance_55}]},24).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},1).to({state:[{t:this.instance_55}]},28).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},6).to({state:[{t:this.instance_55}]},54).to({state:[{t:this.instance_55}]},10).to({state:[{t:this.instance_55}]},4).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_75},{t:this.instance_74},{t:this.instance_73},{t:this.instance_72},{t:this.instance_71},{t:this.instance_70},{t:this.instance_69},{t:this.instance_68},{t:this.instance_67},{t:this.instance_55},{t:this.instance_66},{t:this.instance_65},{t:this.instance_64},{t:this.instance_63},{t:this.instance_62},{t:this.instance_61},{t:this.instance_60},{t:this.instance_59},{t:this.instance_58},{t:this.instance_57},{t:this.instance_56}]},2).to({state:[{t:this.instance_56}]},2).to({state:[{t:this.instance_56}]},2).to({state:[{t:this.instance_56}]},2).to({state:[{t:this.instance_56}]},2).to({state:[{t:this.instance_56}]},2).to({state:[{t:this.instance_55}]},31).to({state:[{t:this.instance_55}]},8).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},2).to({state:[{t:this.instance_55}]},6).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.instance_55).wait(10).to({regX:-31.3,regY:-3.4,rotation:-0.5,x:311.2,y:194.4},0).wait(2).to({regX:-26.9,regY:5.3,rotation:-0.7,x:315.3,y:202},0).wait(2).to({regY:0.7,rotation:-0.3,x:315.2,y:197.3},0).wait(2).to({regY:0.8,rotation:0,y:197.1},0).wait(4).to({regX:-26.7,regY:-3.5,x:315.3,y:193.5},0).wait(44).to({regY:-3.6,rotation:1.5,y:193.4},0).wait(2).to({regY:-3.7,rotation:-4.3},0).wait(2).to({regY:-3.4,rotation:-10,y:193.6},0).wait(2).to({regY:-3.5,rotation:-7.5,x:315.4,y:193.4},0).wait(2).to({regY:-3.4,rotation:-5,y:193.5},0).wait(2).to({regY:-3.5,rotation:-2.5,x:315.3},0).wait(1).to({rotation:0},0).wait(30).to({regX:-31.2,regY:-3.4,rotation:-0.5,x:311.2,y:194.4},0).wait(2).to({regX:-26.9,regY:5.2,rotation:-0.7,x:315.3,y:201.9},0).wait(2).to({regY:0.7,rotation:-0.3,x:315.2,y:197.3},0).wait(2).to({regY:0.8,rotation:0,y:197.1},0).wait(4).to({regX:-26.7,regY:-3.5,x:315.3,y:193.5},0).wait(76).to({regX:-26.8,scaleX:0.84,scaleY:0.94,rotation:-6.8,x:322.7,y:193.6},0).wait(2).to({regX:-26.7,scaleX:0.78,scaleY:0.99,rotation:-13.8,x:330.2,y:193.7},0).wait(2).to({regX:-26.9,regY:-3.4,scaleX:0.73,scaleY:1.03,rotation:-20.7,x:337.6,y:193.8},0).wait(2).to({scaleX:0.78,scaleY:0.89,x:334.1},0).to({_off:true},2).wait(39).to({_off:false,regX:-26.7,regY:-3.5,scaleX:0.89,rotation:0,x:315.3,y:193.5},0).wait(10).to({regX:-31.4,regY:-3.4,rotation:-0.5,x:311.1,y:194.4},0).wait(2).to({regX:-26.9,regY:5.4,rotation:-0.7,x:315.3,y:202.1},0).wait(2).to({regY:0.7,rotation:-0.3,x:315.2,y:197.3},0).wait(2).to({regY:0.8,rotation:0,y:197.1},0).wait(4).to({regX:-26.7,regY:-3.5,x:315.3,y:193.5},0).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_56).wait(197).to({_off:false},0).wait(2).to({regX:22.8,skewX:0,skewY:-180,x:342.6,y:195.6},0).wait(2).to({regY:23.8,scaleY:0.32,skewX:23.3,skewY:-315,x:343,y:192.1},0).wait(2).to({regX:23.2,regY:23.6,scaleX:0.43,scaleY:0.36,skewX:15.5,skewY:-330,x:345.4,y:190},0).wait(2).to({regX:22.7,regY:23.7,scaleX:0.43,scaleY:0.39,skewX:7.8,skewY:-345.2,x:347.3,y:187.8},0).wait(2).to({regX:22.8,regY:23.8,scaleY:0.43,skewX:0,skewY:-360,x:349.4,y:185.7},0).to({_off:true},31).wait(38));

	// Ostrich Head
	this.instance_76 = new lib.OstrichHead_001_1();
	this.instance_76.parent = this;
	this.instance_76.setTransform(302.2,135.8,0.785,0.785,0,0,0,5.2,5.6);

	this.instance_77 = new lib.OstrichHead_003_1();
	this.instance_77.parent = this;
	this.instance_77.setTransform(298.6,136.1,0.785,0.788,0,0,-0.5,4.8,5.6);

	this.instance_78 = new lib.OstrichHead_005_1();
	this.instance_78.parent = this;
	this.instance_78.setTransform(297.6,136.4,0.784,0.786,0,-0.5,-0.8,5.2,5.6);

	this.instance_79 = new lib.OstrichHead_007_1();
	this.instance_79.parent = this;
	this.instance_79.setTransform(296,136.7,0.784,0.785,-0.8,0,0,5,5.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_76}]}).to({state:[{t:this.instance_76}]},8).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},6).to({state:[{t:this.instance_76}]},14).to({state:[{t:this.instance_76}]},24).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_77,p:{regX:4.8,scaleX:0.785,scaleY:0.788,rotation:0,skewY:-0.5,x:298.6,y:136.1,regY:5.6,skewX:0}}]},2).to({state:[{t:this.instance_78,p:{regY:5.6,scaleX:0.784,scaleY:0.786,rotation:0,skewX:-0.5,skewY:-0.8,x:297.6,y:136.4,regX:5.2}}]},2).to({state:[{t:this.instance_79,p:{regX:5,regY:5.6,scaleX:0.784,rotation:-0.8,skewX:0,skewY:0,x:296,y:136.7}}]},1).to({state:[{t:this.instance_78,p:{regY:5.5,scaleX:0.785,scaleY:0.785,rotation:-7.2,skewX:0,skewY:0,x:295.7,y:136.8,regX:5.2}}]},28).to({state:[{t:this.instance_77,p:{regX:5.2,scaleX:0.784,scaleY:0.784,rotation:-7.8,skewY:0,x:295.3,y:137.6,regY:5.6,skewX:0}}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},6).to({state:[{t:this.instance_76}]},54).to({state:[{t:this.instance_76}]},10).to({state:[{t:this.instance_76}]},4).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[]},2).to({state:[{t:this.instance_77,p:{regX:5.2,scaleX:0.785,scaleY:0.785,rotation:0,skewY:0,x:336.5,y:142.8,regY:5.6,skewX:0}}]},2).to({state:[{t:this.instance_79,p:{regX:5.1,regY:6,scaleX:0.785,rotation:0,skewX:-6.9,skewY:173.1,x:351,y:140.3}}]},2).to({state:[{t:this.instance_78,p:{regY:5.6,scaleX:0.784,scaleY:0.784,rotation:0,skewX:-6.8,skewY:173.2,x:353.3,y:138.1,regX:5.4}}]},2).to({state:[{t:this.instance_77,p:{regX:5.4,scaleX:0.784,scaleY:0.784,rotation:0,skewY:173.2,x:354.3,y:136.1,regY:5.5,skewX:-6.8}}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},31).to({state:[{t:this.instance_76}]},8).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},2).to({state:[{t:this.instance_76}]},6).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.instance_76).wait(10).to({regY:5.5,scaleX:0.78,scaleY:0.78,rotation:-3.8,x:298.7,y:136.8},0).wait(2).to({regX:5.3,scaleX:0.79,scaleY:0.79,rotation:-7.9,x:295.2,y:137.8},0).wait(2).to({regX:5.2,regY:5.7,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:298.2,y:137.1},0).wait(2).to({regY:5.6,rotation:-1.8,x:300.4,y:136.3},0).wait(2).to({regX:1.8,regY:5.7,scaleX:0.79,scaleY:0.79,rotation:-0.3,x:299,y:136.1},0).wait(2).to({regX:5.2,regY:5.6,rotation:0,x:302.2,y:135.8},0).wait(46).to({regY:5.7,scaleY:0.79,skewX:0.3,x:302.5,y:135.7},0).wait(2).to({regY:5.6,scaleY:0.79,skewX:0.5,x:302.8,y:135.4},0).wait(2).to({scaleY:0.79,skewX:0.8,x:303.1,y:135.3},0).to({_off:true},2).wait(35).to({_off:false,regX:5.3,regY:5.5,scaleY:0.79,rotation:-7.9,skewX:0,x:295.2,y:137.8},0).wait(2).to({regX:5.2,regY:5.7,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:298.2,y:137.1},0).wait(2).to({regY:5.6,rotation:-1.8,x:300.4,y:136.3},0).wait(2).to({regX:0.2,regY:5.7,scaleX:0.79,scaleY:0.79,rotation:-0.3,x:297.8,y:136.1},0).wait(2).to({regX:5.2,regY:5.6,rotation:0,x:302.2,y:135.8},0).wait(76).to({x:305.3,y:139.7},0).wait(2).to({x:308.4,y:143.6},0).wait(2).to({x:311.4,y:147.5},0).to({_off:true},2).wait(10).to({_off:false,skewX:-6.9,skewY:173.1,x:355.4,y:134.1},0).wait(31).to({skewX:0,skewY:0,x:302.2,y:135.8},0).wait(10).to({regY:5.5,scaleX:0.78,scaleY:0.78,rotation:-3.8,x:298.7,y:136.8},0).wait(2).to({regX:5.3,scaleX:0.79,scaleY:0.79,rotation:-7.9,x:295.2,y:137.8},0).wait(2).to({regX:5.2,regY:5.7,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:298.2,y:137.1},0).wait(2).to({regY:5.6,rotation:-1.8,x:300.4,y:136.3},0).wait(2).to({regX:1.7,regY:5.7,scaleX:0.79,scaleY:0.79,rotation:-0.3,x:299,y:136.1},0).wait(2).to({regX:5.2,regY:5.6,rotation:0,x:302.2,y:135.8},0).wait(18));

	// Neck Feathers
	this.instance_80 = new lib.NeckFeathers();
	this.instance_80.parent = this;
	this.instance_80.setTransform(309.1,185.7,0.754,0.785);

	this.instance_81 = new lib.OstrichWingspanNeck_1();
	this.instance_81.parent = this;
	this.instance_81.setTransform(338,170,0.426,0.426,0,0,180,20.7,72.7);
	this.instance_81._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_80).wait(10).to({rotation:-0.5,y:186.3},0).wait(2).to({rotation:-0.7,y:186.5},0).wait(2).to({rotation:-0.3,y:186.2},0).wait(2).to({rotation:0,y:185.9},0).wait(2).to({y:185.7},0).wait(87).to({rotation:-0.5,y:186.3},0).wait(2).to({rotation:-0.7,y:186.5},0).wait(2).to({rotation:-0.3,y:186.2},0).wait(2).to({rotation:0,y:185.9},0).wait(2).to({y:185.7},0).wait(82).to({_off:true},2).wait(41).to({_off:false},0).wait(10).to({rotation:-0.5,y:186.3},0).wait(2).to({rotation:-0.7,y:186.5},0).wait(2).to({rotation:-0.3,y:186.2},0).wait(2).to({rotation:0,y:185.9},0).wait(2).to({y:185.7},0).wait(20));
	this.timeline.addTween(cjs.Tween.get(this.instance_81).wait(199).to({_off:false},0).wait(2).to({skewY:0,x:349.9,y:167.4},0).wait(2).to({x:350.8,y:165.3},0).wait(2).to({x:351.7,y:163.3},0).wait(2).to({x:352.6,y:161.3},0).to({_off:true},31).wait(38));

	// Ostrich Tail
	this.ostrich_tail_5 = new lib.OstrichTail();
	this.ostrich_tail_5.parent = this;
	this.ostrich_tail_5.setTransform(388.7,177.3,0.785,0.785,0,0,0,2.6,-19.4);

	this.ostrich_tail_6 = new lib.OstrichTail_003();
	this.ostrich_tail_6.parent = this;
	this.ostrich_tail_6.setTransform(388.7,177.3,0.785,0.785,0,0,0,2.6,-19.4);

	this.ostrich_tail_7 = new lib.OstrichTail_002();
	this.ostrich_tail_7.parent = this;
	this.ostrich_tail_7.setTransform(388.7,177.3,0.785,0.785,0,0,0,2.6,-19.4);

	this.ostrich_tail_8 = new lib.OstrichTail_004();
	this.ostrich_tail_8.parent = this;
	this.ostrich_tail_8.setTransform(388.7,177.3,0.785,0.785,0,0,0,2.6,-19.4);

	this.ostrich_tail_9 = new lib.OstrichWingspanTorsoFeathers_1();
	this.ostrich_tail_9.parent = this;
	this.ostrich_tail_9.setTransform(338.8,192.4,0.338,0.308,0,0,0,59.7,52.4);
	this.ostrich_tail_9._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.ostrich_tail_5}]}).to({state:[{t:this.ostrich_tail_5}]},8).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},6).to({state:[{t:this.ostrich_tail_5}]},14).to({state:[{t:this.ostrich_tail_5}]},24).to({state:[{t:this.ostrich_tail_6}]},2).to({state:[{t:this.ostrich_tail_7}]},2).to({state:[{t:this.ostrich_tail_7}]},2).to({state:[{t:this.ostrich_tail_8}]},2).to({state:[{t:this.ostrich_tail_6}]},2).to({state:[{t:this.ostrich_tail_5}]},1).to({state:[{t:this.ostrich_tail_5}]},28).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},6).to({state:[{t:this.ostrich_tail_5}]},54).to({state:[{t:this.ostrich_tail_5}]},10).to({state:[{t:this.ostrich_tail_5}]},4).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[]},2).to({state:[{t:this.ostrich_tail_9}]},2).to({state:[{t:this.ostrich_tail_9}]},2).to({state:[{t:this.ostrich_tail_9}]},2).to({state:[{t:this.ostrich_tail_9}]},2).to({state:[{t:this.ostrich_tail_9}]},2).to({state:[{t:this.ostrich_tail_5}]},31).to({state:[{t:this.ostrich_tail_5}]},8).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},2).to({state:[{t:this.ostrich_tail_5}]},6).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.ostrich_tail_5).wait(10).to({regX:2.2,rotation:-0.5,x:388.4},0).wait(2).to({regX:2.6,rotation:-0.7,x:388.6,y:177.2},0).wait(2).to({regX:2.2,regY:-18.9,rotation:-0.3,x:388.4,y:177.6},0).wait(2).to({regX:2.7,regY:-19.3,rotation:0,x:388.7,y:177.3},0).wait(2).to({regX:2.6,regY:-19.4},0).wait(46).to({_off:true},2).wait(9).to({_off:false},0).wait(30).to({regX:2.2,rotation:-0.5,x:388.4},0).wait(2).to({regX:2.6,rotation:-0.7,x:388.6,y:177.2},0).wait(2).to({regX:2.2,regY:-18.9,rotation:-0.3,x:388.4,y:177.6},0).wait(2).to({regX:2.7,regY:-19.3,rotation:0,x:388.7,y:177.3},0).wait(2).to({regX:2.6,regY:-19.4},0).wait(78).to({regX:2.1,regY:-19.9,scaleX:0.78,scaleY:0.78,rotation:-8.8,x:385.1,y:177.4},0).wait(2).to({regX:2.6,regY:-19.4,rotation:-17.8,x:382.3,y:178},0).wait(2).to({scaleX:0.79,scaleY:0.79,rotation:-27,x:379,y:178.4},0).to({_off:true},2).wait(41).to({_off:false,rotation:0,x:388.7,y:177.3},0).wait(10).to({regX:2.2,rotation:-0.5,x:388.4},0).wait(2).to({regX:2.6,rotation:-0.7,x:388.6,y:177.2},0).wait(2).to({regX:2.2,regY:-18.9,rotation:-0.3,x:388.4,y:177.6},0).wait(2).to({regX:2.7,regY:-19.3,rotation:0,x:388.7,y:177.3},0).wait(2).to({regX:2.6,regY:-19.4},0).wait(20));
	this.timeline.addTween(cjs.Tween.get(this.ostrich_tail_9).wait(199).to({_off:false},0).wait(2).to({regX:59.6,regY:52.5,x:340.7,y:190.9},0).wait(2).to({regX:59.7,regY:52.4,x:342.6,y:189.3},0).wait(2).to({regX:59.6,x:344.6,y:187.7},0).wait(2).to({regX:59.7,regY:52.5,x:346.5,y:186.2},0).to({_off:true},31).wait(38));

	// Ostrich Body Feathers
	this.instance_82 = new lib.OstrichBodyFeathers1();
	this.instance_82.parent = this;
	this.instance_82.setTransform(347.4,183.9,0.752,0.63,-1.9,0,0,49.9,26.1);

	this.instance_83 = new lib.OstrichWingspanTorsoFeathers_1();
	this.instance_83.parent = this;
	this.instance_83.setTransform(341.5,188.8,0.454,0.467,0,0,0,59.8,52.4);
	this.instance_83._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_82).wait(10).to({rotation:-2.3,x:347.5,y:184.1},0).wait(2).to({regX:55.1,regY:25.8,rotation:-2.7,x:351.3,y:183.9},0).wait(2).to({regX:54.9,rotation:-2,x:351.8,y:183.6},0).wait(2).to({regX:55,regY:25.7,rotation:-1.8,x:351.9,y:183.3},0).wait(2).to({regX:54.9,x:351.6},0).wait(2).to({regX:49.9,regY:26.1,rotation:-1.9,x:347.4,y:183.9},0).wait(46).to({regX:50,rotation:-1.8,x:347.5,y:183.7},0).wait(2).to({regY:26,rotation:-1.9,y:183.4},0).wait(2).to({regX:50.1,rotation:-1.8,y:183.6},0).wait(2).to({regY:26.1,x:347.4,y:183.8},0).wait(2).to({regY:26},0).wait(1).to({regX:49.9,regY:26.1,rotation:-1.9,y:183.9},0).wait(30).to({rotation:-2.3,x:347.5,y:184.1},0).wait(2).to({regX:55.1,regY:25.8,rotation:-2.7,x:351.3,y:183.9},0).wait(2).to({regX:54.9,rotation:-2,x:351.8,y:183.6},0).wait(2).to({regX:55,regY:25.7,rotation:-1.8,x:351.9,y:183.3},0).wait(2).to({regX:54.9,x:351.6},0).wait(2).to({regX:49.9,regY:26.1,rotation:-1.9,x:347.4,y:183.9},0).wait(76).to({regX:48.9,regY:26.2,rotation:-1.8,x:349.8,y:183.2},0).wait(2).to({regX:49.9,regY:26.1,x:353.8,y:182.3},0).wait(2).to({rotation:-1.9,x:357.1,y:181.5},0).to({_off:true},2).wait(41).to({_off:false,x:347.4,y:183.9},0).wait(10).to({rotation:-2.3,x:347.5,y:184.1},0).wait(2).to({regX:55.1,regY:25.8,rotation:-2.7,x:351.3,y:183.9},0).wait(2).to({regX:54.9,rotation:-2,x:351.8,y:183.6},0).wait(2).to({regX:55,regY:25.7,rotation:-1.8,x:351.9,y:183.3},0).wait(2).to({regX:54.9,x:351.6},0).wait(2).to({regX:49.9,regY:26.1,rotation:-1.9,x:347.4,y:183.9},0).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_83).wait(199).to({_off:false},0).wait(2).to({x:342.5,y:188.4},0).wait(2).to({x:343.4,y:188.1},0).wait(2).to({x:344.4,y:187.7},0).wait(2).to({x:345.3,y:187.3},0).to({_off:true},31).wait(38));

	// Ostrich Body Feathers
	this.instance_84 = new lib.OstrichBodyFeathers();
	this.instance_84.parent = this;
	this.instance_84.setTransform(332.5,190,1.074,0.828,-16.2,0,0,11.8,35.6);

	this.instance_85 = new lib.OstrichWingspanWing_1();
	this.instance_85.parent = this;
	this.instance_85.setTransform(325.9,180,0.374,0.426,0,-5.2,149.2,10.8,102.4);
	this.instance_85._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_84).wait(10).to({scaleX:1.07,scaleY:0.83,rotation:-16.8,x:332.4,y:190.4},0).wait(2).to({regX:11.6,scaleX:1.07,scaleY:0.83,rotation:-16.9,x:332.3,y:190.6},0).wait(2).to({regX:11.9,regY:35.9,scaleX:1.07,scaleY:0.83,rotation:-16.6,x:332.7,y:190.5},0).wait(2).to({regX:11.6,regY:35.5,rotation:-16.3,x:332.4,y:190.1},0).wait(2).to({regX:11.5,regY:35.6},0).wait(2).to({regX:11.8,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:332.5,y:190},0).wait(46).to({regX:11.3,regY:35.4,scaleX:1.07,scaleY:0.83,rotation:-16.1,x:331.9,y:189.7},0).wait(2).to({regX:11.8,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:332.4,y:189.4},0).wait(2).to({scaleX:1.07,scaleY:0.83,rotation:-16.1,y:189.6},0).wait(2).to({regX:11.3,x:331.9,y:189.9},0).wait(2).to({regX:11.8,x:332.4},0).wait(1).to({regY:35.6,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:332.5,y:190},0).wait(30).to({scaleX:1.07,scaleY:0.83,rotation:-16.8,x:332.4,y:190.4},0).wait(2).to({regX:11.6,scaleX:1.07,scaleY:0.83,rotation:-16.9,x:332.3,y:190.6},0).wait(2).to({regX:11.9,regY:35.9,scaleX:1.07,scaleY:0.83,rotation:-16.6,x:332.7,y:190.5},0).wait(2).to({regX:11.6,regY:35.5,rotation:-16.3,x:332.4,y:190.1},0).wait(2).to({regX:11.5,regY:35.6},0).wait(2).to({regX:11.8,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:332.5,y:190},0).wait(76).to({regY:35.7,scaleX:1.07,scaleY:0.83,rotation:-16.1,x:335,y:189.8},0).wait(2).to({regY:35.6,x:337.7,y:189.6},0).wait(2).to({regY:35.4,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:340.3,y:189.4},0).to({_off:true},2).wait(41).to({_off:false,regY:35.6,x:332.5,y:190},0).wait(10).to({scaleX:1.07,scaleY:0.83,rotation:-16.8,x:332.4,y:190.4},0).wait(2).to({regX:11.6,scaleX:1.07,scaleY:0.83,rotation:-16.9,x:332.3,y:190.6},0).wait(2).to({regX:11.9,regY:35.9,scaleX:1.07,scaleY:0.83,rotation:-16.6,x:332.7,y:190.5},0).wait(2).to({regX:11.6,regY:35.5,rotation:-16.3,x:332.4,y:190.1},0).wait(2).to({regX:11.5,regY:35.6},0).wait(2).to({regX:11.8,scaleX:1.07,scaleY:0.83,rotation:-16.2,x:332.5,y:190},0).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_85).wait(199).to({_off:false},0).wait(2).to({regX:10.7,regY:102.5,scaleX:0.41,skewX:-3.8,skewY:156.9,x:327.6,y:179.4},0).wait(2).to({scaleX:0.44,skewX:-2.5,skewY:164.7,x:329.2,y:178.7},0).wait(2).to({regX:10.8,regY:102.1,scaleX:0.47,skewX:-1.3,skewY:172.4,x:330.9,y:178},0).wait(2).to({regX:10.5,regY:102.5,scaleX:0.51,skewX:0,skewY:180,x:332.5,y:177.4},0).to({_off:true},31).wait(38));

	// Ostrich Torso Feathers 2
	this.instance_86 = new lib.OstrichTorsoFeathers2();
	this.instance_86.parent = this;
	this.instance_86.setTransform(351.9,186.5,0.785,0.785,0,0,0,24.6,32.8);

	this.instance_87 = new lib.OstrichWingspanWing_1();
	this.instance_87.parent = this;
	this.instance_87.setTransform(360.2,180.5,0.44,0.426,0,24.7,41,12.2,109);
	this.instance_87._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_86).wait(10).to({rotation:-0.5,y:186.7},0).wait(2).to({rotation:-0.7,y:186.8},0).wait(2).to({rotation:-0.3,y:186.6},0).wait(2).to({regX:19.4,regY:37.9,rotation:0,x:347.8,y:190.6},0).wait(2).to({regX:24.6,regY:32.8,x:351.9,y:186.5},0).wait(48).to({y:186.3},0).wait(2).to({regY:32.9,y:186.1},0).wait(2).to({regY:32.8,y:186.2},0).wait(2).to({y:186.3},0).wait(2).to({regY:32.9,y:186.4},0).wait(1).to({regY:32.8,y:186.5},0).wait(30).to({rotation:-0.5,y:186.7},0).wait(2).to({rotation:-0.7,y:186.8},0).wait(2).to({rotation:-0.3,y:186.6},0).wait(2).to({regX:19.4,regY:37.9,rotation:0,x:347.8,y:190.6},0).wait(2).to({regX:24.6,regY:32.8,x:351.9,y:186.5},0).wait(78).to({regX:24.4,x:353.4},0).wait(2).to({regY:32.9,x:355},0).wait(2).to({regX:24.6,x:356.8},0).to({_off:true},2).wait(41).to({_off:false,regY:32.8,x:351.9},0).wait(10).to({rotation:-0.5,y:186.7},0).wait(2).to({rotation:-0.7,y:186.8},0).wait(2).to({rotation:-0.3,y:186.6},0).wait(2).to({regX:19.3,regY:38,rotation:0,x:347.7,y:190.6},0).wait(2).to({regX:24.6,regY:32.8,x:351.9,y:186.5},0).wait(20));
	this.timeline.addTween(cjs.Tween.get(this.instance_87).wait(199).to({_off:false},0).wait(2).to({regY:109.1,scaleX:0.46,scaleY:0.43,skewX:17,skewY:29.3},0).wait(2).to({regX:12.1,regY:109,scaleX:0.47,scaleY:0.43,skewX:9.5,skewY:17.6,x:360.3},0).wait(2).to({regY:108.9,scaleX:0.49,skewX:2,skewY:6},0).wait(2).to({regX:12.2,regY:109,scaleX:0.51,rotation:-5.5,skewX:0,skewY:0,x:360.2},0).to({_off:true},31).wait(38));

	// Ostrich Torso Feathers 3
	this.instance_88 = new lib.OstrichTorsoFeathers3();
	this.instance_88.parent = this;
	this.instance_88.setTransform(366.8,184.6,0.785,0.785,0,0,0,22.2,30.1);

	this.instance_89 = new lib.OstrichWingspanTorso_1();
	this.instance_89.parent = this;
	this.instance_89.setTransform(343.5,186.1,0.426,0.426,0,0,0,78.2,60.8);
	this.instance_89._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_88).wait(10).to({rotation:-0.5,x:367,y:184.7},0).wait(2).to({regX:22.4,regY:30,rotation:-0.7,x:366.9},0).wait(2).to({regY:30.1,rotation:-0.3,x:366.8,y:184.6},0).wait(2).to({regY:30,rotation:0,y:184.7},0).wait(2).to({regY:30.1,y:184.6},0).wait(2).to({regX:22.2},0).wait(46).to({y:184.4},0).wait(2).to({y:184.2},0).wait(2).to({y:184.3},0).wait(2).to({y:184.4},0).wait(2).to({y:184.5},0).wait(1).to({y:184.6},0).wait(30).to({rotation:-0.5,x:367,y:184.7},0).wait(2).to({regX:22.4,regY:30,rotation:-0.7,x:366.9},0).wait(2).to({regY:30.1,rotation:-0.3,x:366.8,y:184.6},0).wait(2).to({regY:30,rotation:0,y:184.7},0).wait(2).to({regY:30.1,y:184.6},0).wait(2).to({regX:22.2},0).wait(76).to({x:365.5,y:184.7},0).wait(2).to({x:364.2,y:184.8},0).wait(2).to({x:362.9,y:184.9},0).to({_off:true},2).wait(41).to({_off:false,x:366.8,y:184.6},0).wait(10).to({rotation:-0.5,x:367,y:184.7},0).wait(2).to({regX:22.4,regY:30,rotation:-0.7,x:366.9},0).wait(2).to({regY:30.1,rotation:-0.3,x:366.8,y:184.6},0).wait(2).to({regY:30,rotation:0,y:184.7},0).wait(2).to({regY:30.1,y:184.6},0).wait(2).to({regX:22.2},0).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_89).wait(199).to({_off:false},0).wait(2).to({y:186.4},0).wait(2).to({y:186.6},0).wait(2).to({y:186.8},0).wait(2).to({y:187},0).to({_off:true},31).wait(38));

	// Body
	this.instance_90 = new lib.Body_1();
	this.instance_90.parent = this;
	this.instance_90.setTransform(349.4,184.4,0.785,0.785);

	this.instance_91 = new lib.OstrichWingspanLegFeathers();
	this.instance_91.parent = this;
	this.instance_91.setTransform(349.9,213.9,0.426,0.426,0,0,180,19.8,7.4);
	this.instance_91._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_90).wait(10).to({rotation:-0.5,y:184.6},0).wait(2).to({rotation:-0.7,y:184.7},0).wait(2).to({rotation:-0.3,y:184.6},0).wait(2).to({rotation:0,y:184.5},0).wait(2).to({y:184.4},0).wait(48).to({y:184.2},0).wait(2).to({y:184},0).wait(2).to({y:184.1},0).wait(2).to({y:184.2},0).wait(2).to({y:184.3},0).wait(1).to({y:184.4},0).wait(30).to({rotation:-0.5,y:184.6},0).wait(2).to({rotation:-0.7,y:184.7},0).wait(2).to({rotation:-0.3,y:184.6},0).wait(2).to({rotation:0,y:184.5},0).wait(2).to({y:184.4},0).wait(78).to({scaleX:0.72},0).wait(2).to({scaleX:0.66},0).wait(2).to({scaleX:0.59},0).to({_off:true},2).wait(41).to({_off:false,scaleX:0.79},0).wait(10).to({rotation:-0.5,y:184.6},0).wait(2).to({rotation:-0.7,y:184.7},0).wait(2).to({rotation:-0.3,y:184.6},0).wait(2).to({rotation:0,y:184.5},0).wait(2).to({y:184.4},0).wait(20));
	this.timeline.addTween(cjs.Tween.get(this.instance_91).wait(199).to({_off:false},0).wait(2).to({x:352.8,y:213.7},0).wait(2).to({regX:19.7,x:355.7,y:213.4},0).wait(2).to({regX:19.8,x:358.5,y:213.1},0).wait(2).to({regX:19.7,x:361.5,y:212.9},0).to({_off:true},31).wait(38));

	// Ostrich Neck
	this.instance_92 = new lib.OstrichNeck();
	this.instance_92.parent = this;
	this.instance_92.setTransform(306.3,187.2,0.785,0.785,0,0,0,3.9,31.6);

	this.instance_93 = new lib.OstrichWingspanLegFeathers();
	this.instance_93.parent = this;
	this.instance_93.setTransform(336.4,213.5,0.426,0.44,0,14.3,0,19.8,7.4);
	this.instance_93._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_92).wait(10).to({regX:3.8,scaleX:0.78,scaleY:0.78,rotation:-3.8,x:306.2,y:187.7},0).wait(2).to({regX:3.9,scaleX:0.79,scaleY:0.79,rotation:-7.9,y:188.2},0).wait(2).to({regX:4,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:306.4,y:187.8},0).wait(2).to({regX:3.9,rotation:-1.8,x:306.3,y:187.5},0).wait(2).to({regX:3.8,regY:31.4,scaleX:0.79,scaleY:0.79,rotation:-0.3,y:187.2},0).wait(2).to({regX:3.9,regY:31.6,rotation:0},0).wait(46).to({regX:3.8,scaleY:0.79,skewX:0.3,x:306.2},0).wait(2).to({regX:3.9,regY:31.4,scaleY:0.79,skewX:0.5,x:306.4,y:187},0).wait(2).to({regX:3.8,regY:31.6,scaleY:0.79,skewX:0.8,x:306.3,y:187.2},0).wait(2).to({regX:6.5,regY:31.5,scaleX:0.78,scaleY:0.79,skewX:-3.5,skewY:-4,x:308.3,y:187.1},0).wait(2).to({regX:3.9,regY:31.6,scaleY:0.79,rotation:-6.3,skewX:0,skewY:0,x:306.2,y:187.3},0).wait(1).to({scaleX:0.79,rotation:-7.2},0).wait(30).to({regX:4,scaleX:0.78,scaleY:0.78,rotation:-7.8,x:306.3,y:188},0).wait(2).to({regX:3.9,scaleX:0.79,scaleY:0.79,rotation:-7.9,x:306.2,y:188.2},0).wait(2).to({regX:4,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:306.4,y:187.8},0).wait(2).to({regX:3.9,rotation:-1.8,x:306.3,y:187.5},0).wait(2).to({regX:3.8,regY:31.4,scaleX:0.79,scaleY:0.79,rotation:-0.3,y:187.2},0).wait(2).to({regX:3.9,regY:31.6,rotation:0},0).wait(76).to({scaleX:0.84,scaleY:0.74,skewX:-1.3,skewY:3.8,x:311.1,y:188.1},0).wait(2).to({regY:31.7,scaleX:0.9,scaleY:0.69,skewX:-2.6,skewY:7.5,x:316,y:189},0).wait(2).to({regX:4.3,regY:30.4,scaleX:0.95,scaleY:0.64,skewX:-4.1,skewY:11.5,x:320.9,y:189.8},0).to({_off:true},2).wait(41).to({_off:false,regX:3.9,regY:31.6,scaleX:0.79,scaleY:0.79,skewX:0,skewY:0,x:306.3,y:187.2},0).wait(10).to({regX:3.8,scaleX:0.78,scaleY:0.78,rotation:-3.8,x:306.2,y:187.7},0).wait(2).to({regX:3.9,scaleX:0.79,scaleY:0.79,rotation:-7.9,y:188.2},0).wait(2).to({regX:4,scaleX:0.78,scaleY:0.78,rotation:-4.3,x:306.4,y:187.8},0).wait(2).to({regX:3.9,rotation:-1.8,x:306.3,y:187.5},0).wait(2).to({regX:3.8,regY:31.4,scaleX:0.79,scaleY:0.79,rotation:-0.3,y:187.2},0).wait(2).to({regX:3.9,regY:31.6,rotation:0},0).wait(18));
	this.timeline.addTween(cjs.Tween.get(this.instance_93).wait(199).to({_off:false},0).wait(2).to({regX:19.9,scaleY:0.44,skewX:10.6,x:334.7},0).wait(2).to({regY:7.5,scaleY:0.43,skewX:7,x:333},0).wait(2).to({regY:7.4,scaleY:0.43,skewX:3.5,x:331.4},0).wait(2).to({scaleY:0.43,skewX:0,x:329.7},0).to({_off:true},31).wait(38));

	// Upper Leg
	this.instance_94 = new lib.OstrichLeg();
	this.instance_94.parent = this;
	this.instance_94.setTransform(355.1,237.9,0.785,0.785);

	this.instance_95 = new lib.OstrichWingspanUpperLeftLeg();
	this.instance_95.parent = this;
	this.instance_95.setTransform(348.3,208.4,0.426,0.426,-10.2,0,0,15.1,5.5);
	this.instance_95._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_94).wait(191).to({scaleX:0.75,x:355.5},0).wait(2).to({scaleX:0.72,rotation:-0.1,x:355.9},0).wait(2).to({scaleX:0.69,rotation:-0.3,x:356.4},0).to({_off:true},2).wait(41).to({_off:false,scaleX:0.79,rotation:0,x:355.1},0).wait(38));
	this.timeline.addTween(cjs.Tween.get(this.instance_95).wait(199).to({_off:false},0).wait(2).to({regX:15.2,regY:5.6,rotation:-5.5,x:351.8},0).wait(2).to({regY:6.4,rotation:-1,x:355.2,y:208.5},0).wait(2).to({regX:14.9,regY:5.2,rotation:3.3,x:358.6,y:207.9},0).wait(2).to({regX:16,regY:5.4,rotation:8,x:362.2,y:208},0).to({_off:true},31).wait(38));

	// Front Foot
	this.instance_96 = new lib.OstrichWingspanLeftLowerLeg();
	this.instance_96.parent = this;
	this.instance_96.setTransform(351.2,239.7,0.426,0.429,0,-6.3,0,21.9,7.8);
	this.instance_96._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_96).wait(199).to({_off:false},0).wait(2).to({scaleY:0.43,skewX:-4.6,x:352.3,y:239.8},0).wait(2).to({regY:7.7,scaleY:0.43,skewX:-3,x:353.4,y:239.7},0).wait(2).to({regX:22,skewX:-1.5,x:354.5},0).wait(2).to({regX:21.9,regY:7.8,scaleY:0.43,skewX:0,x:355.5},0).to({_off:true},31).wait(38));

	// Lower Leg
	this.instance_97 = new lib.OstrichWingspanUpperRightLeg_1();
	this.instance_97.parent = this;
	this.instance_97.setTransform(335,212.9,0.441,0.424,0,6.2,-8,11.4,13.7);
	this.instance_97._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_97).wait(199).to({_off:false},0).wait(2).to({regX:11.6,scaleX:0.44,skewX:2.5,x:333.3},0).wait(2).to({regX:11.5,scaleX:0.43,scaleY:0.43,skewX:-1,x:331.6,y:212.8},0).wait(2).to({regX:11.3,regY:13.8,scaleX:0.43,skewX:-4.5,skewY:-8.1,x:329.8,y:212.9},0).wait(2).to({regX:11.6,regY:13.7,scaleX:0.43,scaleY:0.43,rotation:-8.3,skewX:0,skewY:0,x:328.2},0).to({_off:true},31).wait(38));

	// Back Upper Leg
	this.instance_98 = new lib.BackLeg();
	this.instance_98.parent = this;
	this.instance_98.setTransform(344.2,235.4,0.785,0.785);

	this.timeline.addTween(cjs.Tween.get(this.instance_98).wait(191).to({scaleX:0.75,scaleY:0.78,rotation:-2.8,x:345.3},0).wait(2).to({scaleX:0.71,rotation:-5.8,x:346.2},0).wait(2).to({scaleX:0.67,scaleY:0.79,rotation:-8.7,x:347.3,y:235.3},0).to({_off:true},2).wait(41).to({_off:false,scaleX:0.79,rotation:0,x:344.2,y:235.4},0).wait(38));

	// Back Lower Leg
	this.instance_99 = new lib.OstrichWingspanLowerRightLeg();
	this.instance_99.parent = this;
	this.instance_99.setTransform(337.3,258.1,0.426,0.426,0,2.2,0,20.9,49.8);
	this.instance_99._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_99).wait(199).to({_off:false},0).wait(2).to({skewX:1.5},0).wait(2).to({skewX:1},0).wait(2).to({skewX:0.5},0).wait(2).to({regX:21.1,skewX:0,x:337.4},0).to({_off:true},31).wait(38));

	// Layer 10
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#F2F2F2").s().p("AALAWQAAAAgBAAQAAAAAAgBQAAAAAAAAQgBgBAAAAIAAgCIAAAAQgBgEABgCIABgCQAAgBABAAQAAgBAAAAQABAAAAgBQABAAAAAAQACgBADABIACABIADADIAAAFQgBAEgCABIgGABQAEAEAEgCQADgEAAgJQAAgKgJgLQgJgLgKgCQgJgBgJACIgFABIgCAAIAAgBQgBAAAAAAIABgBIAHgCQAKgDALACQALABAKAPQALAOgDALQgDALgDAAIAAAAIgFACQgEAAgDgGgAAOAKIgCACQgCADABADIABABQAIACAAgEQABgFgCgBIgDgBIgCAAg");
	this.shape_1.setTransform(343.3,201.3);

	this.instance_100 = new lib.ToucanTween8s1("synched",0);
	this.instance_100.parent = this;
	this.instance_100.setTransform(343.3,201.3);

	this.instance_101 = new lib.eeeeeeeeee("synched",0);
	this.instance_101.parent = this;
	this.instance_101.setTransform(343.3,201.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1}]}).to({state:[{t:this.shape_1}]},26).to({state:[{t:this.shape_1}]},14).to({state:[{t:this.shape_1}]},81).to({state:[{t:this.shape_1}]},54).to({state:[{t:this.shape_1}]},10).to({state:[{t:this.instance_100}]},4).to({state:[{t:this.instance_100}]},2).to({state:[{t:this.instance_100}]},2).to({state:[{t:this.instance_101}]},2).to({state:[]},2).to({state:[{t:this.shape_1}]},41).to({state:[{t:this.shape_1}]},26).wait(12));
	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(185).to({_off:true},4).wait(49).to({_off:false},0).wait(38));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(581.3,272.7,449.3,175.5);
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWostrich_atlas_.png?1528312843618", id:"MWostrich_atlas_"},
		{src:"sounds/GleamAfterDrying5wav.mp3?1528312844055", id:"GleamAfterDrying5wav"},
		{src:"sounds/sesame_murray_ostrich_00_intro_squawk.mp3?1528312844055", id:"sesame_murray_ostrich_00_intro_squawk"},
		{src:"sounds/sesame_murray_ostrich_03_zoom_squawk.mp3?1528312844055", id:"sesame_murray_ostrich_03_zoom_squawk"}
	],
	preloads: []
};




})(lib_Ostrich = lib_Ostrich||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Ostrich, images, createjs, ss, AdobeAn;